<template>
<!-- eslint-disable max-len -->
<span>
  <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOut">
    <div class="report-container" id="report-container">
      <div :class="`report ${pdf ? 'pdf' : ''}`" ref="report" id="report">
        <div
          v-if="pageGenerating === 0 || !pdf"
          class="report-page-1"
          style="
            padding: 0 0 16px;
          "
        >
          <div :class="`report-header ${pdf ? 'pdf' : ''}`">
            <!-- logo -->
            <!-- <img v-if="logo" :src="resolveAssetPath(logo, 'ui/customer')" :class="`logo ${pdf ? 'pdf' : ''}`" ref="logo"> -->

            <img
              ref="headingBG"
              src="../../../assets/ui/reports/headingBG.svg"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 65%;
                object-fit: contain;
                z-index: 0;
              "
            />

            <!-- title -->
            <h1 class="report-title no-wrap">{{activeEnvironment.reportTitle || game.reportTitle || 'Report'}}</h1>
            <!-- date -->
            <div
              class="no-wrap"
              style="
                font-size: 1.2em;
                z-index: 1;
                align-self: flex-end;
              "
            >
              職涯規劃評估日期: {{date}}
            </div>
          </div>

          <!-- name/gender -->
          <div :style="{
            display: 'flex',
            'flex-flow': 'row nowrap',
            'justify-content': 'flex-start',
            padding: '30px 50px 4px',
            'font-size': '2.2em',
            gap: '48px',
          }">
            <div class="no-wrap">
              {{username}}
            </div>
            <img
              v-if="genderIcon === 'm'"
              src="../../../assets/ui/reports/male.png"
              style="width: 36px; height: 36px; object-fit: contain;"
            />
            <img
              v-else-if="genderIcon === 'f'"
              src="../../../assets/ui/reports/female.png"
              style="width: 36px; height: 36px; object-fit: contain;"
            />
          </div>

          <!-- demographics + best fit role -->
          <div
            style="
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
              padding: 8px 0 8px 50px;
              gap: 4px;
              font-size: 1.3em;
            "
          >
            <!-- demographics -->
            <div
              style="
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                gap: 30px;
              "
            >
              <div style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                gap: 4px;
                color: #e92e89;
              ">
                <!-- <div class="no-wrap">
                  出生年份
                </div> -->
                <div class="no-wrap">
                  居住地區
                </div>
                <div class="no-wrap">
                  現時工作狀況
                </div>
                <div class="no-wrap">
                  現時 (或最近) 的工作行業
                </div>
                <!-- <div class="no-wrap">
                  現時 (或最近) 的工作職銜
                </div>
                <div class="no-wrap">
                  工作年數
                </div> -->
              </div>
              <div style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                gap: 4px;
                color: black;
                width: 170px;
              ">
                <!-- <div class="no-wrap">
                  {{birthYear}}
                </div> -->
                <div class="no-wrap">
                  {{location}}
                </div>
                <div class="no-wrap">
                  {{employed}}
                </div>
                <div class="no-wrap" style="overflow: hidden; text-overflow: ellipsis;">
                  {{industry}}
                </div>
                <!-- <div class="no-wrap" style="overflow: hidden; text-overflow: ellipsis;">
                  {{jobTitle}}
                </div>
                <div class="no-wrap">
                  {{workYears}}
                </div> -->
              </div>
            </div>

            <!-- radar -->
            <radar
              :stats2="categoryScores"
              polycolor2="rgba(233, 46, 137, 0.5)"
              :stats="bestFitRoleCategoryScores"
              polycolor="rgba(0, 204, 193, 0.5)"
              :radar="radar"
              :gridlineCount="4"
              gridlineColor="#004282"
              axesColor="#004282"
              fillColor="white"
              halfwayFillColor="transparent"
              :borderWidth="5"
              borderColor="#004282"
              :labelSize="0"
              labelColor="transparent"
              :startingAngleRadians="2.08"
              :maxValue="maxRadarValue"
              style="
                width: 300px;
                height: 280px;
                margin-top: -16px;
              "
            ></radar>

            <!-- best fit role -->
            <div style="
              position: relative;
              width: 320px;
              padding-top: 42px;
            ">
              <div
                class="no-wrap"
                style="
                  border-radius: 24px 0 0 24px;
                  margin-top: -42px;
                  padding: 4px 16px;
                  background: linear-gradient(to right, #004282, #e92e89);
                  color: white;
                  position: absolute;
                  right: 0;
                "
              >
                <!-- Role: -->
                你選擇的崗位: {{ bestFitRole.name }}
              </div>
              <div
                class="no-wrap"
                style="
                  color: #e92e89;
                  font-size: 3em;
                  line-height: 1.1;
                  padding-left: 12px;
                  margin-top: 8px;
                  width: 100%;
                "
              >
                {{ bestFitScore.toFixed(1) }} %
              </div>
              <div
                class="no-wrap"
                style="
                  font-size: 0.93em;
                  padding-left: 18px;
                  margin-top: -4px;
                "
              >
                你的遊戲評估與選擇職位的匹配度
              </div>
              <div
                style="
                  padding-left: 12px;
                  margin-top: 24px;
                  display: flex;
                  flex-flow: column nowrap;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    gap: 6px;
                  "
                >
                  <div
                    style="
                      border-radius: 50%;
                      width: 24px;
                      height: 24px;
                      background-color: #00ccc1;
                    "
                  >
                  </div>
                  <!-- desired score -->
                  <div class="no-wrap">
                    建議達標分數
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    gap: 6px;
                  "
                >
                  <div
                    style="
                      border-radius: 50%;
                      width: 24px;
                      height: 24px;
                      background-color: #e92e89;
                    "
                  >
                  </div>
                  <!-- your score -->
                  <div class="no-wrap">
                    你的分數
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SEN -->
          <div
            style="
              margin-top: 8px;
              padding: 8px 50px;
              font-size: 1.65em;
              display: flex;
              flex-flow: row nowrap;
              align-items: center;
              gap: 12px;
            "
          >
            <img
              src="../../../assets/ui/reports/specialNeeds.png"
              style="width: 32px; height: 32px; object-fit: contain;"
            />
            <!-- SPECIAL EDUCATION OVERVIEW -->
            <div class="no-wrap">
              特殊教育概要
            </div>
          </div>
          <div
            class="no-wrap"
            style="
              margin: 0 50px;
              border-radius: 24px;
              padding: 20px 36px;
              background: linear-gradient(to right, #bacceb, #c5eee7);
              color: #004282;
              font-size: 1.3em;
            "
          >
            {{ senReferenceValue }}
          </div>

          <!-- abilities -->
          <div
            style="
              margin-top: 32px;
              padding: 8px 8px 8px 50px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
            "
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                gap: 70px;
              "
            >
              <div
                style="
                  font-size: 1.65em;
                  display: flex;
                  flex-flow: row nowrap;
                  align-items: center;
                  gap: 12px;
                "
              >
                <img
                  src="../../../assets/ui/reports/abilities.png"
                  style="width: 32px; height: 32px; object-fit: contain;"
                />
                <!-- YOUR ABILITY -->
                <div class="no-wrap">
                  你的能力評估 (針對農場工作，滿分為10分)
                </div>
              </div>
              <!-- ability bars -->
              <div
                style="
                  font-size: 1.3em;
                  display: flex;
                  flex-flow: column wrap;
                  align-items: center;
                  gap: 12px 24px;
                  max-height: 240px;
                "
              >
                <div
                  v-for="(abilityCat, index) in categoryScores"
                  :key="`yourabilitycat${index}`"
                >
                  <div
                    style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: flex-end;
                      justify-content: space-between;
                      gap: 12px;
                      min-width: 330px;
                    "
                  >
                    <div class="no-wrap">
                      {{ abilityCat.name }}
                    </div>
                    <div class="no-wrap" style="font-size: 1.32em; color: #e92e89;">
                      {{ (Math.round(abilityCat.value * 10) / 10).toFixed(1) }}
                    </div>
                  </div>
                  <div
                    style="
                      margin-top: 6px;
                      width: 100%;
                      height: 12px;
                      background-color: #d7d7d7;
                      border-radius: 4px;
                      position: relative;
                    "
                  >
                    <div
                      style="
                        height: 12px;
                        border-radius: 4px;
                        position: absolute;
                        top: 0;
                        left: 0;
                      "
                      :style="{
                        width: `${Math.min(100, Math.max(0, abilityCat.value * 100 / 10))}%`,
                        backgroundColor: abilityCategories[index].color,
                      }"
                    >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- capability wheel -->
            <capability-wheel
              style="
                height: 375px;
                width: 375px;
              "
              :capabilities="wheelCapabilityData"
              disableShadow
              disableNontopGreyout
              outerLabelSize="16px"
              innerLabelColor="black"
              categoryBorderColor="#004282"
              flippedFill
              :numArcs="6"
            ></capability-wheel>
          </div>

          <div
            style="
              margin-top: 24px;
              margin-bottom: 24px;
              margin-right: 50px;
              padding: 28px 28px 28px 50px;
              background-color: white;
              border-radius: 0 24px 24px 0;
              min-height: 135px;
            "
          >
            {{ abilityBlurb }}
          </div>

          <!-- attitudes -->
          <div
            style="
              margin-top: 32px;
              width: 100%;
              padding: 8px 8px 8px 50px;
            "
          >
            <div
              style="
                width: 100%;
                display: flex;
                flex-flow: column nowrap;
                gap: 12px;
              "
            >
              <div
                style="
                  font-size: 1.65em;
                  display: flex;
                  flex-flow: row nowrap;
                  align-items: center;
                  gap: 12px;
                "
              >
                <img
                  src="../../../assets/ui/reports/attitude.png"
                  style="width: 32px; height: 32px; object-fit: contain;"
                />
                <!-- YOUR ATTITUDE -->
                <div class="no-wrap">
                  你的工作態度 (滿分為10分)
                </div>
              </div>
              <!-- attitude bars -->
              <div
                style="
                  font-size: 1.3em;
                  display: flex;
                  flex-flow: column wrap;
                  gap: 8px 24px;
                  height: 269px;
                  width: 1050px;
                "
              >
                <div
                  v-for="(attitudeCat, index) in attitudeScores"
                  :key="`yourabilitycat${index}`"
                  style="
                    width: 45%;
                    max-height: calc(25% - 6px);
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: flex-end;
                      justify-content: space-between;
                      gap: 12px;
                      margin-bottom: 4px;
                    "
                    :style="{
                      'max-width': `max(185px, ${Math.min(100, Math.max(0, attitudeCat.value * 100 / 10))}%)`,
                    }"
                  >
                    <div class="no-wrap">
                      {{ attitudeCat.name }}
                    </div>
                    <div class="no-wrap" style="font-size: 1.32em; color: #e92e89;">
                      {{ (Math.round(attitudeCat.value * 10) / 10).toFixed(1) }}
                    </div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      height: 16px;
                      position: relative;
                    "
                  >
                    <img
                      src="../../../assets/ui/reports/AttitudeBG.png"
                      style="
                        height: 100%;
                        width: 100%;
                        object-fit: fill;
                        position: absolute;
                        top: 0;
                        left: 0;
                      "
                    />
                    <img
                      src="../../../assets/ui/reports/AttitudeFill.png"
                      style="
                        height: 100%;
                        object-fit: fill;
                        position: absolute;
                        top: 0;
                        left: 0;
                      "
                      :style="{
                        width: `${Math.min(100, Math.max(0, attitudeCat.value * 100 / 10))}%`,
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- upcareer logo -->
          <div
            style="
              padding: 20px 50px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              src="../../../assets/ui/reports/upCareer_logo-small.png"
              style="height: 48px; object-fit: contain;"
            />
          </div>

          <!-- footer -->
          <div
            v-if="pdf && (activeEnvironment.reportFooter || activeEnvironment.reportFooterLogo)"
            style="
              background-color: black;
              color: white;
              padding: 4px 50px;
              width: 100%;
              min-height: 36px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
              align-items: flex-start;
            "
          >
            <!-- footer message (e.g. displaying ©) -->
            <div v-html="activeEnvironment.reportFooter"></div>
            <!-- footer logo -->
            <img
              v-if="activeEnvironment.reportFooterLogo"
              :src="resolveAssetPath(activeEnvironment.reportFooterLogo, 'ui/customer')"
              :class="`footer-logo ${pdf ? 'pdf' : ''}`"
              ref="footerLogo"
            >
          </div>
        </div>
        <div
          v-if="pageGenerating === 1 || !pdf"
          class="report-page-2"
          style="
            padding: 4px 0 16px;
          "
        >
          <!-- ability archetype -->
          <div
            style="
              margin: 0 0 3px 50px;
              padding: 8px 26px 2px 16px;
              border-radius: 48px 0 0 48px;
              border: solid 1px #e92e89;
              border-right: none;
              background-color: white;
              width: calc(100% - 50px);
              height: 308px;
              font-size: 1.1em;
              display: flex;
              flex-flow: row nowrap;
              gap: 24px;
            "
          >
            <div
              style="
                padding: 16px 0;
                width: 120px;
                height: 100%;
                display: flex;
                flex-flow: column nowrap;
                align-items: center;
                gap: 6px;
              "
            >
              <!-- attitude archetype icons -->
              <img
                v-if="bestFitArchetypeIndex === 0"
                src="../../../assets/ui/reports/NatureExplorer.png"
                style="height: 120px; width: 120px; object-fit: contain; border-radius: 50%;"
              />
              <img
                v-else-if="bestFitArchetypeIndex === 1"
                src="../../../assets/ui/reports/CommunityConnector.png"
                style="height: 120px; width: 120px; object-fit: contain; border-radius: 50%;"
              />
              <img
                v-else-if="bestFitArchetypeIndex === 2"
                src="../../../assets/ui/reports/ActiveBuilder.png"
                style="height: 120px; width: 120px; object-fit: contain; border-radius: 50%;"
              />
              <img
                v-else-if="bestFitArchetypeIndex === 3"
                src="../../../assets/ui/reports/GentleNurturer.png"
                style="height: 120px; width: 120px; object-fit: contain; border-radius: 50%;"
              />
              <img
                v-else-if="bestFitArchetypeIndex === 4"
                src="../../../assets/ui/reports/MindfulSolver.png"
                style="height: 120px; width: 120px; object-fit: contain; border-radius: 50%;"
              />
              <img
                v-else-if="bestFitArchetypeIndex === 5"
                src="../../../assets/ui/reports/PuzzleMaster.png"
                style="height: 120px; width: 120px; object-fit: contain; border-radius: 50%;"
              />

              <div
                style="
                  width: 100%;
                  padding: 16px 0;
                  text-align: center;
                  white-space: pre-wrap;
                "
              >{{ bestFitArchetype.shortDescription }}</div>
            </div>
            <div
              style="
                width: calc(100% - 120px);
                height: 100%;
                display: flex;
                flex-flow: column nowrap;
                justify-content: space-between;
                gap: 12px;
              "
            >
              <div
                class="no-wrap"
                style="
                  width: 100%;
                  font-size: 1.44em;
                  color: #e92e89;
                "
              >
                {{bestFitArchetype.name}}
              </div>
              <div
                style="
                  width: 100%;
                  color: black;
                  padding-right: 32px;
                "
              >
                {{bestFitArchetype.longDescription}}
              </div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-flow: row nowrap;
                  gap: 24px;
                "
              >
                <div
                  class="no-wrap"
                  style="
                    width: 120px;
                  "
                >
                  適合你的工作角色:
                </div>
                <ul
                  style="
                    width: calc(100% - 144px);
                    color: black;
                  "
                >
                  <li
                    v-for="(suggestedJob, sIndex) in bestFitArchetype.suggestedJobs"
                    :key="`suggestedJob${sIndex}`"
                  >
                    {{ suggestedJob }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- desired job role -->
          <div
            style="
              padding: 16px 0 0 50px;
              width: 100%;
              display: flex;
              flex-flow: row nowrap;
              align-items: center;
              justify-content: space-between;
              gap: 12px;
            "
          >
            <div
              style="
                font-size: 1.65em;
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                gap: 12px;
              "
            >
              <img
                src="../../../assets/ui/reports/attitude.png"
                style="width: 32px; height: 32px; object-fit: contain;"
              />
              <!-- DESIRED JOB ROLES -->
              <div class="no-wrap">
                你有興趣的工作崗位
              </div>
            </div>
            <div
              class="no-wrap"
              style="
                font-size: 1.35em;
                border-radius: 24px 0 0 24px;
                padding: 4px 85px 4px 16px;
                background: linear-gradient(to right, #004282, #e92e89);
                color: white;
              "
            >
              <!-- Most Desired Job Role: -->
              你選擇的崗位: {{ desiredRole ? desiredRole.name : '' }}
            </div>
          </div>

          <!-- all job roles -->
          <div
            style="
              padding: 15px 50px 16px;
              width: 100%;
              display: flex;
              flex-flow: row nowrap;
              align-items: center;
              justify-content: space-between;
              gap: 6px;
            "
          >
            <div
              v-for="(role, index) in sortedRoles"
              :key="`desiredrole${index}`"
              style="
                width: 23.5%;
                height: 192px;
                border-radius: 24px;
                padding: 24px;
                display: flex;
                flex-flow: column nowrap;
                align-items: center;
                gap: 6px;
                background: linear-gradient(to right, #bacceb, #c5eee7);
                font-size: 1.35em;
              "
            >
              <div
                style="
                  text-align: center;
                  line-height: 1.12;
                  height: 50px;
                "
              >
                {{ role.name }}
              </div>
              <div
                style="
                  font-size: 0.95em;
                  color: black;
                "
              >
                {{ role.description }}
              </div>
            </div>
          </div>

          <!-- ability improvement suggestions for desired job role -->
          <div
            style="
              padding: 8px 50px;
              width: 100%;
              display: flex;
              flex-flow: row wrap;
              justify-content: space-around;
              gap: 2.75%;
            "
          >
            <div
              v-for="(leastFitAbility, index) in leastFitAbilities"
              :key="`leastFitAbility${index}`"
              style="
                width: 31.5%;
                color: white;
                font-size: 1.12em;
                line-height: 1.25;
              "
            >
              <div
                style="
                  background: linear-gradient(to bottom right, #004282, #e92e89);
                  border-radius: 24px 24px 0 0;
                  text-align: center;
                  height: 81px;
                  width: 100%;
                  display: flex;
                  flex-flow: column nowrap;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div class="no-wrap">
                  {{ leastFitAbility.improvementInfo.displayName }}
                </div>
                <div
                  class="no-wrap"
                  style="
                    font-size: 1.5em;
                    line-height: 1.14;
                  "
                >
                  {{ (Math.round(leastFitAbility.abilityScore * 10) / 10).toFixed(1) }}
                </div>
              </div>
              <div
                style="
                  background-color: white;
                  color: black;
                  border: solid 1px #e92e89;
                  min-height: 243px;
                  width: 100%;
                  padding: 0 12px 4px;
                "
              >
                <div
                  style="
                    color: #e92e89;
                    text-align: center;
                    padding: 16px 0;
                  "
                >
                  差異
                </div>
                <div
                  style="
                    font-size: 0.9em;
                  "
                >
                  {{ leastFitAbility.improvementInfo.feedbackByJobRole[bestFitRoleIndex].differenceText }}
                </div>
              </div>
              <div
                style="
                  background: linear-gradient(to bottom right, #004282, #e92e89);
                  border-radius: 0 0 24px 24px;
                  min-height: 702px;
                  width: 100%;
                  padding: 0 12px 4px;
                "
              >
                <div
                  style="
                    text-align: center;
                    padding: 16px 0;
                  "
                >
                  建議改善方式
                </div>
                <ul
                  style="
                    padding-left: 22px;
                  "
                >
                  <li
                    v-for="
                      (suggestedImprovement, sIndex) in leastFitAbility.improvementInfo.feedbackByJobRole[bestFitRoleIndex].suggestedImprovements
                    "
                    :key="`suggestedImprovement${sIndex}`"
                  >
                    {{ suggestedImprovement }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- upcareer logo -->
          <div
            style="
              padding: 1px 50px 1px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              src="../../../assets/ui/reports/upCareer_logo-small.png"
              style="height: 48px; object-fit: contain;"
            />
          </div>

          <!-- footer -->
          <div
            v-if="pdf && (activeEnvironment.reportFooter || activeEnvironment.reportFooterLogo)"
            style="
              background-color: black;
              color: white;
              padding: 4px 50px;
              width: 100%;
              min-height: 36px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
              align-items: flex-start;
            "
          >
            <!-- footer message (e.g. displaying ©) -->
            <div v-html="activeEnvironment.reportFooter"></div>
            <!-- footer logo -->
            <img
              v-if="activeEnvironment.reportFooterLogo"
              :src="resolveAssetPath(activeEnvironment.reportFooterLogo, 'ui/customer')"
              :class="`footer-logo ${pdf ? 'pdf' : ''}`"
              ref="footerLogo"
            >
          </div>
        </div>
      </div>
    </div>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="showDownloading" class="download-message">Downloading!</div>
  </transition>

  <!-- Email Report -->
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <button v-if="showNextButton"
      class="btn download-button"
      :style="{
        height:
          narrative.downloadButtonHeight
            ? narrative.downloadButtonHeight
            : undefined,
        width:
          narrative.downloadButtonWidth
            ? narrative.downloadButtonWidth
            : '350px',
        bottom:
          narrative.downloadButtonYOffset
            ? `calc(210px + ${narrative.downloadButtonYOffset})`
            : '300px',
        right:
          narrative.downloadButtonXOffset
            ? `-${narrative.downloadButtonXOffset}`
            : '0',
      }"
      @click.prevent="onClickSendEmail"
    ><div v-html="narrative.emailButtonText || '傳送報告到電郵'"></div></button>
    <!-- TODO: change the default text back to English, dynamic email report button styling similar to download -->
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <button v-if="showNextButton"
      class="btn download-button"
      :style="{
        height:
          narrative.downloadButtonHeight
            ? narrative.downloadButtonHeight
            : undefined,
        width:
          narrative.downloadButtonWidth
            ? narrative.downloadButtonWidth
            : '350px',
        bottom:
          narrative.downloadButtonYOffset
            ? `calc(210px + ${narrative.downloadButtonYOffset})`
            : '210px',
        right:
          narrative.downloadButtonXOffset
            ? `-${narrative.downloadButtonXOffset}`
            : '0',
      }"
      @click.prevent="onClickDownload"
    ><div v-html="narrative.downloadButtonText || 'Download'"></div></button>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <bottom-bar
      :next="(showNextButton && showNarratorNotification) ? onComplete : undefined"
      :tabindex="3"
      ref="bottomBar"
      noBar
      narrativeStyle
    >
      <span slot="button">
        <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
      </span>
    </bottom-bar>
  </transition>
</span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import JsPDF from 'jspdf';
import domtoimage from 'dom-to-image-more';
import { axiosAPIInstance as axios } from '../../../axios-config';

import Narrator from '../ui/Narrator';
import NarratorNotification from '../ui/NarratorNotification';
import BottomBar from '../ui/BottomBar';
import CapabilityWheel from '../ui/CapabilityWheel';
import Radar from '../ui/Radar';

export default {
  // $emit 'input' on complete
  components: {
    Narrator,
    NarratorNotification,
    BottomBar,
    CapabilityWheel,
    Radar,
  },
  data() {
    return {
      // *** narrative state variables ***
      showNextButton: false,
      showNarrator: false,
      showNarratorNotification: false,
      showDownloading: false,
      pdf: false, // toggles on layout adjustments for PDF generation and page printing
      pageGenerating: 0, // 0 = first page, 1 = second page (toggles during PDF generation)

      // *** configuration variables ***
      radar: {
        size: '300',
        viewbox: '600',
        radius: '260',
      },
      maxRadarValue: 10,
      abilityCategories: [
        // I. Work Environment
        { name: '工作環境適應能力', color: '#eabf85' },
        // II. Teamwork & Independence
        { name: '團隊合作與溝通能力', color: '#becee9' },
        // III. Physical Capabilities
        { name: '體能與勞動執行能力', color: '#ec722f' },
        // IV. Work Competence
        { name: '農場實務工作能力', color: '#75d1c8' },
        // V. Cognitive Tasks
        { name: '認知與學習能力', color: '#de6fa1' },
        // VI. Detail-Oriented Tasks
        { name: '細心程度與觀察準確性', color: '#376aae' },
      ],
      /** role ability/category scores from sheet:
       * https://docs.google.com/spreadsheets/d/1jQILteSO_Ks_H2eaC1XF5NPiYnFUtwIx/edit?gid=15560402
       */
      roles: [
        {
          // Farm Systems Maintenance Officer
          name: '農場系統維護員',
          description: '負責農場系統及設施的日常運作與維護',
          abilityScores: [
            9, 9.5, 9.5, 10,
            8.5, 8.5, 9, 8,
            8, 9, 8.5, 8.5,
            8, 7.5, 8.5, 8,
            9.5, 9, 9.5, 10,
            9.5, 9, 9.5, 10,
          ],
          abilityWeights: [
            0.22, 0.25, 0.25, 0.28,
            0.25, 0.25, 0.29, 0.21,
            0.21, 0.29, 0.25, 0.25,
            0.25, 0.21, 0.29, 0.25,
            0.25, 0.22, 0.25, 0.28,
            0.25, 0.22, 0.25, 0.28,
          ],
          categoryScores: [9.5, 8.5, 8.5, 8, 9.5, 9.5],
        },
        {
          // Planting Technician
          name: '種植技術員',
          description: '負責播種、育苗、種植及日常種植工作',
          abilityScores: [
            8.5, 9.5, 7.5, 8.5,
            8, 8.5, 7.5, 8,
            9, 9.5, 8.5, 9,
            9, 9.5, 10, 9.5,
            8, 8.5, 8, 7.5,
            9.5, 9.5, 9.5, 9.5,
          ],
          abilityWeights: [
            0.25, 0.32, 0.18, 0.25,
            0.25, 0.29, 0.21, 0.25,
            0.25, 0.28, 0.22, 0.25,
            0.22, 0.25, 0.28, 0.25,
            0.25, 0.29, 0.25, 0.21,
            0.25, 0.25, 0.25, 0.25,
          ],
          categoryScores: [8.5, 8, 9, 9.5, 8, 9.5],
        },
        {
          // Ecological Care Trainer
          name: '生態照護導師',
          description: '負責照顧魚類及農場生態',
          abilityScores: [
            8.5, 9, 8, 8.5,
            9.5, 9, 9.5, 10,
            7.5, 8.5, 8, 8,
            9.5, 9.5, 9.5, 9.5,
            9, 9, 9.5, 8.5,
            9.5, 9, 8.5, 9,
          ],
          abilityWeights: [
            0.25, 0.29, 0.21, 0.25,
            0.25, 0.22, 0.25, 0.28,
            0.21, 0.29, 0.25, 0.25,
            0.25, 0.25, 0.25, 0.25,
            0.25, 0.25, 0.28, 0.22,
            0.28, 0.25, 0.22, 0.25,
          ],
          categoryScores: [8.5, 9.5, 8, 9.5, 9, 9],
        },
        {
          // Operations & Harvest Manager
          name: '營運與收成管理員',
          description: '負責收成、包裝及農場營運安排',
          abilityScores: [
            9, 8.5, 9.5, 9,
            9.5, 9, 10, 9.5,
            8.5, 9, 8.5, 8,
            9, 9, 9, 9,
            9.5, 9, 9.5, 10,
            9, 8.5, 9, 9.5,
          ],
          abilityWeights: [
            0.25, 0.22, 0.28, 0.25,
            0.25, 0.22, 0.28, 0.25,
            0.25, 0.29, 0.25, 0.21,
            0.25, 0.25, 0.25, 0.25,
            0.25, 0.22, 0.25, 0.28,
            0.25, 0.22, 0.25, 0.28,
          ],
          categoryScores: [9, 9.5, 8.5, 9, 9.5, 9],
        },
      ],
      /** chosen by highest-scoring ability category, ordered the same as `abilityCategories` / `categoryScores` */
      archetypes: [
        {
          // Nature Explorer
          name: '🌿 自然探索者',
          shortDescription:
`守規律
喜整齊
愛自然
工作穩定性高`,
          longDescription: '你是大自然的孩子，最開心的時候就是在戶外呼吸新鮮空氣並投入工作！你喜歡穩定、有規律的環境，就像每天太陽升起時便清楚自己要做什麼。你對整潔有要求，最不喜歡在混亂中工作。農場、園藝、環境管理——這些都非常適合你！你的力量來自冷靜與穩定，是團隊中的安心守護者！',
          suggestedJobs: [
            '日常巡查與狀況觀察（例如溫室及田間巡查、觀察植物生長狀況、留意病害或異常情況）',
            '種植及農務操作支援（協助播種、收割、清潔種植區、整理工具及維持工作環境整齊）',
            '水耕及設施管理（操作及監察水耕系統、檢查灌溉設備運作、協助進行水質測試）',
            '流程跟從與穩定執行（按既定程序完成工作、確保每個步驟準確執行、維持系統穩定運作）',
          ],
        },
        {
          // Community Connector
          name: '🤝 你是社區聯繫者',
          shortDescription:
`善溝通
適應力高
能獨立
擅協作`,
          longDescription: '你是橋樑的建設者，懂得如何連接人與人之間！你不怕合作，也能獨立完成工作。在團隊中，你就像齒輪一樣，讓整個運作更加順暢。你善於觀察他人的情緒，懂得在適當時候伸出援手，也知道何時給予空間，展現出極大的體貼與細心。',
          suggestedJobs: [
            '團隊溝通與協調支援（協助團隊成員之間溝通、傳達工作安排、支援日常協作）',
            '導賞與簡介講解（向訪客、學生或新同事介紹農場環境、基本運作流程及安全須知）',
            '培訓與現場支援（協助培訓活動進行、示範基本工作步驟、在現場提供即時協助）',
            '關係建立與互動引導（與不同對象建立良好互動、留意他人需要及反應、營造友善工作氣氛）',
          ],
        },
        {
          // Active Builder
          name: '💪 積極建設者',
          shortDescription:
`實幹型
體能強
動作靈活
學以致用`,
          longDescription: '你是現場的戰士，雙手就是你最強大的武器！你喜歡親身操作，從實踐中學習，不怕流汗，愈做愈有幹勁。你做事不僅依靠頭腦，更重視動作與身體的配合。搬運、清潔、整理器材，這些都難不倒你。',
          suggestedJobs: [
            '體力型搬運與物資處理（協助搬運農產品、工具或物資，按指示完成上落貨及整理工作）',
            '設備操作與協助支援（協助使用或整理農業設備，配合其他同事完成指定操作）',
            '清潔與基礎保養工作（清潔水管、濾網及相關設備，保持系統暢通及運作安全）',
            '環境整理與安全維護（維持工作區域整潔，留意地面、工具及設備的安全狀況）',
          ],
        },
        {
          // Gentle Nurturer
          name: '🌱 溫柔呵護者',
          shortDescription:
`同理心強
觀察細膩
願意照顧
能應對失落`,
          longDescription: '你是大自然的守護者，對生命有特別的感受。你會因一棵不健康的菜而擔心，也會耐心觀察每一條魚的食量。你明白照顧需要耐性、細心與情感，不僅是做事，更是投入感情。你不怕混亂，也不怕困難，只怕自己照顧得不夠好。',
          suggestedJobs: [
            '植物日常養護與觀察（照顧植物生長狀況、澆水、修剪，留意是否出現病害或異常）',
            '魚缸及水質管理（協助管理魚缸環境、觀察魚隻狀況、進行基本水質檢查）',
            '有機養殖支援工作（協助有機養殖流程，按指引處理飼料、清潔及日常維護）',
            '細節觀察與即時回報（留意植物及魚類的細微變化，並向主管回報異常情況）',
          ],
        },
        {
          // Mindful Solver
          name: '🔰 用心解決者',
          shortDescription:
`邏輯清晰
有記性
專注細節
冷靜分析`,
          longDescription: '你是用心解決者，擅長發現細節、梳理流程、記住每一個小步驟。你善於觀察、分析與解決問題，並在工作中持續優化流程、提升品質。當其他人覺得「這樣應該沒問題」時，你會追問：「為什麼不把它再做好一點？」',
          suggestedJobs: [
            '數據紀錄與資料整理（整理種植、水質或操作紀錄，確保資料清晰、準確及易於查閱）',
            '水質監控與指標檢查（定期檢測水質數據，如酸鹼度、氨氮及硝酸鹽，並記錄變化）',
            '流程觀察與問題識別（留意日常運作流程，發現重複或低效的步驟）',
            '支援流程改進與優化（協助提出改善建議，測試更有效的操作方式或工具使用）',
          ],
        },
        {
          // Puzzle Master
          name: '🧠 解謎⼤師',
          shortDescription:
`邏輯清晰
有記性
專注細節
冷靜分析`,
          longDescription: '你天⽣就是觀察⾼⼿，擁有⼀雙「鷹眼」，能夠察覺到別⼈經常忽略的⼩細節。不論是模式、數字、流程或規則，只要稍加觀察，你就能找出其中的邏輯與問題所在。你熱愛動腦、分析，喜歡按部就班地解決難題。在⾯對複雜或結構性的任務時，你通常⽐他⼈更快理解重點，並有效處理。你並不追求熱鬧刺激，⽽是享受深⼊思考與邏輯推理帶來的滿⾜感。你也擅⻑遵從步驟與標準流程，是⼀位值得信賴的問題解決者。',
          suggestedJobs: [
            '數據紀錄與持續追蹤（記錄及整理種植、生產或系統運作數據，定期檢視變化趨勢）',
            '程序管理與執行（按既定流程設定及操作系統，確保每個步驟準確完成）',
            '品質檢查與標準確認（檢查植物健康狀況、產品包裝及流程結果是否符合標準）',
            '流程觀察與改善支援（協助分析現有操作流程，提出優化建議並支援測試新做法）',
          ],
        },
      ],
      abilityImprovementInformation: [
        {
          // Enjoys outdoor work
          abilityName: '喜歡戶外工作',
          displayName: '喜歡戶外工作',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '在農場系統維護工作中，員工需要長時間於戶外或半戶外環境中工作，例如檢查水循環系統、維修管道設備或處理突發狀況。這些工作通常需要面對不同天氣條件（如炎熱、潮濕或降雨）以及環境變化。相比理想狀態，你目前對戶外工作的適應程度及投入感仍有一定距離，這可能會影響你的專注度、工作持續性以及整體表現。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '先從短時間的戶外巡查開始，例如檢查水泵或管道15分鐘，適應後再慢慢增加時間',
                '出發前準備好帽子、防水手套及防滑鞋，讓自己在農場戶外環境感覺舒適安全 ',
                '如果戶外環境讓你感到不舒服，立即告訴主管，一起商量是否可以調整工作安排 ',
                '在戶外工作時，把注意力放在檢查設備或觀察植物狀態上，讓工作更有目標感',
                '記住每次在戶外完成巡查或維修工作，都是在保護整個農場系統的穩定運作',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員的工作主要在戶外田間進行，包括播種、移植幼苗及巡查植物生長狀況。相比理想狀態，你目前對戶外工作環境的舒適程度及投入感仍有一定差距，可能影響你在田間工作時的專注力及在不同天氣下持續工作的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '上班前查看天氣預報，了解今天田間的溫度和天氣，讓自己提前有心理準備',
                '根據天氣準備好裝備：晴天帶帽子及防曬衣，潮濕天氣帶防水外套及防滑鞋',
                '在戶外工作時，找出自己感覺最舒服的時段（例如早上較涼快時）安排較繁重的任務',
                '每隔一至兩小時，到有遮蔭的地方休息五分鐘並補充水分，養成固定的休息習慣',
                '如果某種天氣讓你特別困難，事先告知主管，商討是否可以調整到較舒適的工作時段',
                '把戶外工作視為觀察植物生長的機會，留意今天的種植區和昨天有什麼不同',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師每天在魚菜共生農場的魚缸區域工作，環境特點包括長期高濕度、魚缸設備的背景噪音，以及隨天氣變化的溫度和光線。相比理想狀態，你目前對在這種半戶外魚類護理環境中持續工作的舒適程度及投入感仍有一定差距，可能影響你在工作時的專注力及對整體工作環境的接受度。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '上班前查看天氣預報，了解今天魚缸區域的溫度和濕度，讓自己提前有心理準備',
                '根據天氣準備好裝備：高濕度環境帶透氣工作服，在魚缸旁工作穿防水靴及防水手套',
                '在魚缸旁工作時，把注意力放在觀察魚隻的游動和進食反應上，讓工作更有目標感',
                '每隔一至兩小時，主動到通風較好的位置休息五分鐘並補充水分，養成固定的休息習慣',
                '如果某種環境條件讓你特別困難（例如高濕度或噪音），事先告知主管，商討是否可以調整',
                '記住每次在魚缸旁完成護理工作，都是在保護這些魚隻的健康和生命',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員每天需要在多個不同環境之間切換，包括戶外收割、溫室包裝及農場巡查，每個環境都有不同的感官條件。相比理想狀態，你目前對在多個戶外及半戶外環境之間切換工作的舒適程度仍有差距，可能影響你在不同工作環境中維持穩定表現的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '上班前查看天氣預報，了解今天魚缸區域的溫度和濕度，讓自己提前有心理準備 ',
                '根據天氣準備好裝備：高濕度環境帶透氣工作服，在魚缸旁工作穿防水靴及防水手套',
                '在魚缸旁工作時，把注意力放在觀察魚隻的游動和進食反應上，讓工作更有目標感',
                '每隔一至兩小時，主動到通風較好的位置休息五分鐘並補充水分，養成固定的休息習慣',
                '如果某種環境條件讓你特別困難（例如高濕度或噪音），事先告知主管，商討是否可以調整',
                '記住每次在魚缸旁完成護理工作，都是在保護這些魚隻的健康和生命',
              ],
            },
          ],
        },
        {
          // Likes routine tasks
          abilityName: '喜愛例行性工作',
          displayName: '喜愛例行性工作',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作包含大量重複性及標準化的日常任務，例如設備檢查、水質測量、系統清潔及例行維護等。這些工作雖然重複，但對維持系統穩定運作至關重要。相比理想狀態，你目前對於重複性工作的接受程度及穩定執行能力仍有提升空間，可能會影響工作的一致性與可靠性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的系統巡查工作寫成清單，完成一項就打剔，清楚看到自己的工作進度',
                '把較大的維護任務分成小步驟，例如先檢查水泵，再檢查管道，一次只專注一步',
                '為自己設定小目標，例如「今天完成所有水質測量記錄」，完成後給自己一個肯定',
                '用清單追蹤每天的巡查進度，確保每個設備和系統都有被檢查，沒有任何遺漏',
                '記住你每天做的例行巡查和維護，正是讓整個魚菜共生系統穩定運作的重要原因',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員每天需要在固定時間完成播種、澆水、施肥及修剪等重複性工作。相比理想狀態，你目前對固定工作流程的接受程度及持續執行的能力仍有一定差距，可能影響農作物的生長質素及日常種植工作的穩定性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理每天的固定工作清單，列明每項種植任務的執行時間和順序，貼在顯眼位置',
                '每完成一項例行種植任務就在清單上打剔，讓自己清楚看見一天的工作進度',
                '如果某個固定步驟讓你難以投入，為它訂立小目標，例如「今天把這一排植物全部修剪整齊」',
                '執行例行任務時，可以同時聆聽輕音樂（在農場環境允許下），幫助自己保持舒適的工作狀態',
                '若主管臨時改變工作順序，先問清楚新的流程，把它寫下來，再按更新後的清單執行 ',
                '記住每次按時完成例行種植工作，就是在守護這批植物的健康成長',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師每天需要在固定時間完成餵飼、水質測量、魚缸清潔及記錄魚隻狀態等重複性工作，魚類的健康對這些工作的時間性和一致性要求極高。相比理想狀態，你目前對固定護理流程的接受程度及持續穩定執行的能力仍有差距，可能對魚隻的健康帶來風險。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理每天的固定護理工作清單，列明每個魚缸的餵飼時間、水質測量和清潔程序，貼在顯眼位置',
                '每完成一項例行護理任務就在清單上打剔，讓自己清楚看見一天的工作進度',
                '如果某個固定步驟讓你難以投入，為它訂立小目標，例如「今天把所有魚缸的水質測量全部完成」',
                '執行例行護理任務時，可以同時聆聽輕音樂（在農場環境允許下），幫助自己保持舒適的工作狀態 ',
                '若主管臨時調整餵飼份量或程序，先問清楚新的要求，把它寫下來，再按更新後的清單執行',
                '記住每次按時完成例行護理工作，就是在守護每一條魚隻的健康和生存',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員的工作多樣性高，但仍有固定程序可依循，例如每天定時農場巡查、包裝操作流程及收割工具的清潔程序。相比理想狀態，你目前在多樣性高的工作環境中尋找並依靠固定程序的能力仍有差距，可能影響你在工作安排較彈性時維持工作效率的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理出這個崗位中有固定程序的工作環節，例如每日農場巡查路線、包裝操作標準步驟及收割工具清潔程序，製作成清晰的操作清單',
                '每天開始工作時，先確認哪些任務是固定程序性的、哪些是今天特定情況下才有的彈性任務，先安排固定程序任務',
                '對於包裝等需要重複操作的固定任務，建立固定操作節奏，例如每次按「檢查、秤重、裝袋、封口、標籤」的固定順序',
                '當某天工作安排因突發情況改變時，先完成當天的固定程序性任務，再處理彈性安排的工作',
                '建立每天工作結束時的固定「收尾程序」，例如清潔工具、完成工作記錄、確認農場各區域安全狀態',
              ],
            },
          ],
        },
        {
          // Adapts to changes
          abilityName: '能適應變化',
          displayName: '能適應變化',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場環境具有高度變動性，例如天氣變化、設備故障、水質波動或突發運作問題，均需要即時調整工作方式。相比理想狀態，你在面對變化時的靈活性及應對能力仍有提升空間，這可能影響你在不確定情境中的表現與效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '問主管哪些農場情況最常突然改變，例如設備故障或水質異常，提前了解有心理準備',
                '如果系統出現突發故障，先深呼吸，然後問主管：「現在我應該先處理哪一件事？」',
                '把突發情況分成兩類：「我可以按程序自己處理的」和「我需要立即告訴主管的」',
                '每次成功應對突發維修情況後，和主管一起回顧，了解哪裡做得好、下次怎樣改進',
                '記住農場設備突發問題是每個維護員都會遇到的挑戰，不只是你才會感到困難',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植工作雖然有規律，但農場環境隨時可能出現突發變化，例如惡劣天氣需要緊急保護植物、發現蟲害需要即時更改工作計劃。相比理想狀態，你目前在面對突發情況時保持冷靜及靈活應對的能力仍有差距，可能影響你的情緒穩定性與工作效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管預先制定「突發情況應對指引」，列出農場常見的突發狀況（例如大雨、蟲害）及第一步行動',
                '當計劃改變時，先做三件事：停下來、深呼吸、然後問主管「接下來我應該做什麼？」',
                '把每次突發情況分成兩個問題：「這件事安全嗎？」和「我需要通知主管嗎？」再決定下一步',
                '每次成功應對突發情況後，和主管一起回顧，了解哪些反應是正確的、哪裡可以改進',
                '在日常種植工作中練習「小彈性」，例如今天先澆水再修剪，逐漸建立對變化的適應能力',
                '記住農場環境的突發情況是所有種植員都需要面對的，感到緊張時立即告訴主管',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師的日常工作雖有規律，但魚類養殖環境隨時可能出現突發情況，例如水質突然超出安全範圍、魚隻出現異常症狀或設備突然故障。相比理想狀態，你目前在面對計劃外的突發情況時保持冷靜及有效應對的能力仍有差距，可能影響魚隻在緊急狀況下得到及時照護的機會。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管預先制定「魚缸突發情況應對指引」，列出常見突發狀況（例如水質超標、魚隻浮頭）及第一步行動',
                '當計劃改變時，先做三件事：停下來、深呼吸、然後問主管「現在我應該先做什麼？」',
                '把每次突發情況分成兩個問題：「這件事安全嗎？」和「我需要立即通知主管嗎？」再決定下一步',
                '每次成功應對突發護理情況後，和主管一起回顧，了解哪些反應是正確的、哪裡可以改進',
                '在日常護理工作中練習「小彈性」，例如今天先測量水質再餵飼，逐漸建立對變化的適應能力',
                '記住魚缸環境的突發情況是所有魚類護理員都需要面對的，感到緊張時立即告訴主管',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員是農場中最需要應對突發變化的崗位，例如大雨需要緊急提前收割、突然發現蟲害需要立即改變工作計劃，以及包裝設備故障需要即時找到替代方案。相比理想狀態，你目前在面對計劃外的突發變化時保持冷靜及快速重組工作優先次序的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理一份「農場常見突發情況應對指引」，涵蓋最常遇到的突發類型，例如緊急提前收割、大範圍蟲害發現、包裝設備故障，讓每種突發都有清晰的第一步行動框架',
                '學習把突發情況應對分成三步：第一步停下來評估情況、第二步決定最優先的一件事、第三步行動並通知主管',
                '每天開始工作前，花兩至三分鐘思考「今天的工作中最有可能出現什麼突發情況？如果出現了，我的第一步是什麼？」',
                '在日常工作中主動練習彈性切換，例如今天先處理蟲害巡查再進行包裝，逐步提升對計劃改變的適應能力',
                '每次成功應對突發情況後，與主管一起回顧：情況怎樣出現、我的應對哪裡做得好、下次可以怎樣更快更好',
              ],
            },
          ],
        },
        {
          // Tidiness
          abilityName: '注重整潔',
          displayName: '注重整潔',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '在農場系統維護中，整潔與有序是確保效率、安全及系統穩定的重要因素，包括工具擺放、設備區域清潔及操作後的整理習慣。相比理想水平，你在維持工作環境整齊及建立穩定整理習慣方面仍有進步空間，這可能影響工作效率及錯誤風險。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每次完成維修或保養工作後，立即清理工具並放回原位，不要等到工作結束才整理',
                '為每種工具設定固定存放位置並貼上標籤，讓自己每次都能快速找到所需的工具',
                '每天工作結束前，用五分鐘做固定整理程序，確保維修區域和工具房保持乾淨整潔',
                '使用簡單的整理清單，確認每樣工具和零件都已歸位，確保維修工作區域沒有遺漏',
                '從工具箱或維修台開始培養整潔習慣，慢慢擴展到整個農場維護工作的區域範圍',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植區域的整潔直接影響農作物的健康，包括工具用後歸位、清理植物殘株及整理灌溉管道等。相比理想狀態，你目前在主動維持種植工作環境整潔及有條理管理工具與物料方面仍有差距，可能影響農場衛生標準與整體工作效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天工作結束前，設定最後10分鐘清潔工具、將工具放回指定位置、清理種植床的植物殘株',
                '為農場工具區製作「工具位置對照圖」，用後對照圖確認歸位，讓歸還工具成為有規則的動作',
                '在工作過程中養成「用完即清」的習慣，例如修剪後的枝葉立即放入指定廢料桶，不讓雜物積累',
                '如果某個整理任務讓你困惑，主動詢問主管農場的具體處理程序，把步驟記下來備用',
                '每週與主管一起快速巡查種植區，確認工具擺放和廢料處理是否符合農場的整潔標準',
                '記住整齊的種植環境讓你更容易找到工具，也讓植物在更健康的環境中生長',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類養殖工作對工作環境整潔的要求非常嚴格，因為魚缸周邊的衛生狀況直接影響水質，而水質是魚隻健康生存的核心條件。相比理想狀態，你目前在魚缸工作區域主動維持整潔及有系統地管理工具和設備方面仍有差距，可能對魚缸水質衛生和魚隻健康帶來直接影響。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每次完成餵飼後，立即清理魚缸邊緣的飼料殘渣，養成「餵飼完成、立即清潔」的連貫操作習慣',
                '為魚缸工作區域的每種工具設定固定存放位置並貼上標籤，使用後對照標籤確認歸位',
                '水質測量儀器每次使用後，按程序用清水沖洗乾淨並妥善存放，確保下次測量結果準確',
                '每天工作結束前，設定最後10分鐘清洗所用工具、確認工具歸位、清理工作台和地面',
                '在日常工作中養成「即時處理」習慣：發現地面有水漬立即擦乾，廢料立即放入指定廢料區',
                '記住整潔的魚缸工作環境不只是工作習慣，它直接影響魚缸水質和每條魚隻的健康生存',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員的工作涉及多個操作區域，整潔有序直接影響農產品食品安全和農場操作安全，例如收割工具未清潔可能傳播病害，化學品存放混亂可能造成危險。相比理想狀態，你目前在多個工作區域中主動維持整潔及有系統地管理工具和物料方面仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '為每個主要工作區域（收割區、包裝區、農藥存放區、工具存放區）分別建立「區域整潔標準清單」，每次離開某個工作區域前對照清單快速確認 ',
                '建立「使用後立即清潔歸位」的工具管理習慣，特別是收割工具，每次使用後立即沖洗乾淨放回指定位置，避免病害傳播',
                '在包裝區工作時，建立「處理完一批即清理一次」的習慣，每完成一批農產品的包裝，立即清理工作台上的廢料和殘葉',
                '對農藥和化學品的存放建立嚴格標準，每種化學品放在固定標籤位置，使用後確認蓋好並記錄使用份量和日期 ',
                '每天工作結束前，設定最後十五分鐘為全面的「工作區域整理時間」，依次完成清潔工具、清理廢料、確認農場通道暢通',
              ],
            },
          ],
        },
        {
          // Teamwork
          abilityName: '團隊合作',
          displayName: '團隊合作',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作涉及多個崗位的協作，例如與種植員、魚類護理員及設施管理人員協調，共同確保農場系統正常運作。員工需要清晰地分工、互相更新工作進度，並在出現問題時及時通報。相比理想狀態，你目前在主動與他人協作、配合團隊節奏及共同解決問題方面仍有一定距離，這可能影響整體農場系統的運作效率與安全性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天開始工作前，查看工作分工表，了解自己的維護任務和其他崗位的工作怎樣配合',
                '和種植技術員或生態照護導師建立溝通習慣，完成影響他們的維護工作後主動告知',
                '用簡單方式分享維護進度，例如在白板寫下今天完成了哪些系統檢查，讓同事了解狀態',
                '完成一項影響其他崗位的維護任務時，例如調整灌溉系統，記得主動通知相關同事',
                '不確定某個維護情況是否需要通知其他崗位時，問自己：「這會影響他們的工作嗎？」',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員需要與農場系統維護員、生態照護導師及營運人員保持協調，確保種植工作與農場整體運作一致。相比理想狀態，你目前在主動與其他崗位協作及分享工作進度方面仍有差距，可能影響農場生產流程的順暢性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天工作開始前，花幾分鐘了解今天哪些種植任務可能影響其他崗位，例如收割前需要提前通知誰',
                '當你完成一項影響其他崗位的任務（例如完成移植或發現植物異常），立即通知相關同事或主管',
                '與固定的一至兩位同事建立日常溝通習慣，例如每天收工前互相更新工作重點一句話',
                '需要與不熟悉的同事合作時，先問主管：「今天我和＿＿需要如何配合？」讓協作有清晰框架',
                '在團隊工作中，你的責任是清楚完成自己的種植部分，並在完成後讓相關同事知道',
                '若在協作過程中感到困惑或不舒適，立即告訴主管，主管可以幫你找到更適合的協作方式',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師需要與種植技術員、農場系統維護員及營運人員保持協調，因為魚類健康直接影響水質，水質又影響植物生長。相比理想狀態，你目前在主動與其他崗位協作及適時分享魚類護理重要資訊方面仍有差距，可能影響農場整體生態系統的穩定性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天開始工作前，了解今天的水質狀況是否需要通知系統維護員，或魚隻情況是否需要告知種植技術員',
                '當你發現魚缸水質數據出現異常，立即通知主管和相關同事，不要等到問題嚴重才開口',
                '與固定的一至兩位同事建立日常溝通習慣，例如每天完成護理後更新水質狀況給種植技術員',
                '需要與不熟悉的同事協調魚缸清洗或維修工作時，先問主管：「我和＿＿需要如何配合？」',
                '在團隊工作中，你的責任是清楚完成自己的魚類護理部分，並在完成後讓相關同事知道',
                '若在協作過程中感到困惑或不舒適，立即告訴主管，主管可以幫你找到更適合的協作方式',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要與農場所有崗位保持最廣泛的協作，包括協調種植技術員的收割安排、與系統維護員配合蟲害防治，以及向農場管理層更新收成進度。相比理想狀態，你目前在主動跨崗位協作及整合多方資訊以推進農場整體運作方面仍有差距，可能影響農場的整體協調效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天早上工作開始前，主動了解其他崗位今天的工作重點，例如詢問種植技術員今天是否有種植操作影響收割區域進出',
                '需要跨崗位協作時，清楚說明你需要對方配合什麼、在什麼時間、需要多長時間，讓協作請求具體而有預期',
                '建立固定的跨崗位資訊分享習慣，例如每天工作結束前，向相關同事更新當天收成和包裝的完成情況',
                '在農忙時期，主動與主管討論當天各崗位之間的協作安排，確認每個崗位的工作優先次序和互相配合的時間節點',
                '當跨崗位協作出現分歧或誤解時，直接以平靜的態度說明你的理解，例如「我以為我們說好了＿＿，可以確認一下嗎？」',
              ],
            },
          ],
        },
        {
          // Solo work
          abilityName: '獨立工作',
          displayName: '獨立工作',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作中，有許多任務需要獨立完成，例如定期檢查水泵、記錄系統數據或更換設備零件。這些工作需要員工能夠按照程序自行完成任務，並在沒有人即時指示的情況下保持專注和準確性。相比理想狀態，你目前在獨立處理較長時間的任務、自行判斷優先次序及在無人監督下維持工作質素方面仍有一定差距，這可能影響工作的連貫性與準確性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '為每項獨立維護工作準備清楚的步驟清單，每完成一步就打剔，知道下一步要做什麼',
                '為自己設定工作時間目標，例如「早上九點前完成所有魚缸水質測量」，讓節奏更有結構',
                '不確定維護程序的下一步時，先回到操作手冊或清單查看，不要憑感覺猜測做法',
                '完成每項維護任務後，把結果記錄下來，例如水溫和pH值數字，作為自我檢查的習慣',
                '遇到設備異常不知道怎樣處理時，立即告訴主管，不需要自己一個人想辦法解決',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員有大量工作需要獨立完成，包括逐株播種、巡查植物健康及自行完成施肥和修剪。相比理想狀態，你目前在長時間獨立執行種植任務及在無人監督下維持工作標準方面仍有差距，可能導致部分任務被跳過或工作質素不一致。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的種植任務轉化成具體的工作清單，每完成一步就打剔，讓清單成為獨立工作時的方向指引',
                '為自己設定清晰的時間節點，例如「早上10點前完成播種，11點前完成澆水」，讓工作節奏有結構',
                '獨立工作時，如果不確定某個步驟怎樣執行，先暫停記下問題，下次見到主管時詢問',
                '完成每項獨立任務後，用30秒回顧：「我是否按程序完成了？有沒有遺漏的步驟？」',
                '如果某個種植任務需要長時間重複，例如連續移植一整排幼苗，分成幾個小段落，完成每段稍作休息 ',
                '記住你每天按計劃完成的獨立種植任務，直接決定這批農作物能否按時健康成長',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師大部分時間在沒有主管即時監督的情況下獨立工作，需要按固定時間表完成餵飼、水質測量和魚缸清潔等護理工作。相比理想狀態，你目前在獨立執行魚類護理任務及在無人監督下維持護理標準方面仍有差距，可能導致某些護理步驟被省略或工作質素出現波動。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每次魚類護理工作的完整步驟整理成清單，包括餵飼、水質測量、記錄和清潔的先後順序',
                '為每天的獨立護理任務設定具體時間目標，例如「早上10時前完成所有魚缸的第一次餵飼和水質測量」',
                '獨立工作時，若遇到不確定的情況，先把觀察記錄下來並拍照，再聯絡主管尋求指示',
                '完成每個魚缸的護理後，花十至十五秒快速回顧：「我有沒有完成這個魚缸今天所需的所有步驟？」',
                '如果在獨立工作期間感到精神疲勞，允許自己短暫休息五分鐘再繼續，不要在精神不集中的狀態下強行完成',
                '記住能夠獨立穩定地完成魚類護理工作，是這個崗位最核心的能力，每天按計劃完成就是建立信任的基礎',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員有大量獨立工作需要自主完成，例如農場巡查、蟲害記錄、收割工具維護及包裝工序管理，而且這些獨立工作的內容多樣性比其他崗位更高。相比理想狀態，你目前在獨立處理多樣性高的農場任務及自主管理工作節奏和優先次序方面仍有差距，可能影響農場整體運作效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理一份「獨立工作授權清單」，清楚列明哪些農場任務可以自主完成、哪些情況需要先通知主管，讓獨立工作有清晰邊界',
                '每天早上用五分鐘制定「當日優先任務清單」，把需要獨立完成的任務按照緊迫程度排列，讓自己在獨立工作時有清晰的執行順序',
                '在農場巡查中使用固定的巡查路線和觀察清單，確保每次巡查都覆蓋所有需要檢查的區域和項目，避免因工作多樣性而遺漏',
                '獨立工作中遇到需要判斷的情況時，先根據主管事先提供的指引自行評估，把評估結果記錄下來，再在下次見到主管時確認',
                '每天工作結束前，花五分鐘完成「每日工作總結」，記錄完成的工作、未完成的事項和明天需要優先跟進的內容',
              ],
            },
          ],
        },
        {
          // Decision making
          abilityName: '決策能力',
          displayName: '決策能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作中，員工有時需要即時作出判斷，例如在發現系統異常時決定是否立即停機、是否需要通報主管，或是否可以按照既有程序自行處理。相比理想狀態，你目前在面對突發情況時快速評估、選擇適當行動方案及承擔決策責任方面仍有一定距離，這可能導致處理問題時出現延誤或錯誤判斷。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '和主管提前制定「常見設備問題應對清單」，列出遇到問題時可以對照使用的處理方法',
                '學習把情況分成兩類：「我可以按程序自己處理的」和「我需要立即告訴主管的」',
                '需要作決定時，先問自己：這安全嗎？這符合維護程序嗎？我有信心嗎？三個都是才行動',
                '每次處理完設備突發問題後，和主管回顧你做了什麼，了解哪裡做得好、哪裡可以改進',
                '記住在安全範圍內按程序作出決定再跟進，永遠比什麼都不做、一直等待要好',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員在田間工作時，經常需要即時判斷植物狀況，例如發現葉片枯黃或蟲害跡象時，決定是繼續觀察還是立即通報主管。相比理想狀態，你目前在獨立評估植物狀況及判斷應採取何種行動方面仍有差距，可能影響農場的種植成果。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理一份「植物狀況對照卡」，列明常見異常表徵（例如葉片發黃、葉面有斑點）及建議行動',
                '學習把植物狀況分成三類：「正常繼續觀察」、「有點不對記錄並告知主管」、「明顯異常立即通報」',
                '每次發現植物異常，先用手機拍照或記錄下來，再向主管匯報，共同作出更準確的判斷',
                '不確定是否需要行動時，問自己：「如果我現在什麼都不做，這批植物明天會更差嗎？」如果是，就告知主管',
                '每次與主管處理完一個植物問題後，問主管：「我的判斷對嗎？下次怎樣更早發現？」逐步建立自信',
                '記住在種植工作中，早一步發現問題並告知主管，永遠比等問題嚴重後才處理要好',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師在日常工作中經常需要即時判斷，例如當水質數值超出安全範圍時，需要決定是立即採取緊急措施還是通知主管；當魚隻出現異常時，需要判斷是否需要即時隔離。相比理想狀態，你目前在評估護理情況及判斷行動緊迫性方面仍有差距，可能影響魚隻得到及時保護的機會。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管制定一份「魚缸護理決策指引」，列出不同水質數值的應對級別（正常、需監測、需立即行動）及處理步驟',
                '學習把情況分成三類：「正常按程序繼續」、「有疑問記錄並盡快通知主管」、「緊急立即行動並同步通知主管」',
                '需要作決定時，先問自己：「如果我現在不採取行動，魚隻的情況會在一小時內變差嗎？」',
                '每次作出較重要的護理判斷後，用一兩句話把決定和理由記在工作日誌中，讓決定有記錄可追蹤',
                '每次與主管一起處理完一個魚缸護理問題後，問主管：「我的判斷合適嗎？下次怎樣更好地處理？」',
                '記住在魚類護理工作中，不確定時告知主管永遠比自行猜測要安全，主動尋求指示是負責任的表現',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要作出的決定數量最多、範圍最廣，例如判斷農作物最佳收割時機、決定是否剔除未達標準的農產品，以及在突發情況下重新排列工作優先次序。相比理想狀態，你目前在快速評估農場運作情況及作出平衡多方考量的判斷方面仍有差距，可能影響農場關鍵時刻的決策質素。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管為這個崗位最常需要判斷的情境建立「決策參考指引」，例如收割時機的判斷標準（顏色、大小、硬度等具體指標）及農產品品質篩選的標準',
                '學習在作出決定前快速進行三項評估：這個決定影響範圍是什麼、如果現在不決定後果多快出現、這個決定是否在我的工作授權範圍內',
                '建立「決定後記錄」習慣：每次作出較重要的判斷後，用一兩句話把決定和理由記在工作日誌中，讓決定有文字記錄可追蹤',
                '不確定某個判斷是否正確時，先採取「最保守的安全選項」，例如不確定農作物是否可以收割時，選擇延後而非立即收割',
                '每次與主管回顧一個你作出的判斷後，主動詢問：「我這次的判斷依據是否合理？有什麼我沒考慮到的因素？」',
              ],
            },
          ],
        },
        {
          // Communication skills
          abilityName: '溝通能力',
          displayName: '溝通能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作中，溝通是日常工作的重要部分，包括向主管匯報系統狀況、向同事交接任務，以及在發生問題時清晰說明情況。相比理想狀態，你目前在主動開口表達、清楚描述問題及在壓力情況下有效溝通方面仍有一定差距，這可能導致重要資訊未能準時傳達，影響農場系統的安全與效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '試試用這個句式向主管匯報：「我完成了＿＿，發現了＿＿，下一步我打算＿＿」',
                '如果不習慣口頭表達，可以用文字或訊息溝通，例如發訊息給主管說明設備的狀態',
                '每天結束工作前，用一兩句話告訴主管今天的系統狀況，養成每天定期溝通的習慣',
                '聽到維護指示但不明白時，不要假裝明白，說：「我想確認一下，你的意思是＿＿嗎？」',
                '描述設備問題時，用具體事實，例如「水泵的運作聲音比平時大，已持續約30分鐘」',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員需要向主管匯報植物生長狀況、在交接班時清楚告知同事工作進度，以及在遇到不明白的指示時主動提問。相比理想狀態，你目前在主動分享工作狀態及用清晰語言描述植物情況方面仍有差距，可能影響農場的整體種植決策。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '學習用固定句式匯報種植情況：「今天我在＿＿區域發現＿＿，我的觀察是＿＿，這是否正常？」',
                '如果不習慣口頭表達，可以拍下植物照片配上一句描述發送給主管，書面溝通同樣有效',
                '每天工作結束前，用一兩句話告訴主管當天最重要的一件事，讓溝通成為日常工作節奏的一部分',
                '聽到指示但不完全理解時，說：「我想確認一下，你的意思是要我先完成＿＿，然後再做＿＿，對嗎？」',
                '描述植物狀況時，用具體事實而非感覺，例如「這株植物底部有三片葉子變黃，用手碰感覺較軟」',
                '記住你在田間的觀察是主管無法隨時親眼看到的第一手資料，你說出的每個觀察都可能很重要',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師需要向主管清楚描述魚缸水質數據和魚隻健康狀況、在交班時準確告知同事護理情況，以及在發現異常時用清晰語言描述所見情況。相比理想狀態，你目前在主動分享護理資訊及準確描述魚隻和水質狀況方面仍有差距，可能影響農場在緊急情況下的整體應對能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '學習用固定句式向主管匯報：「今天＿＿號魚缸的＿＿數值是＿＿，魚隻游動（正常/異常），我（已/未）採取＿＿行動」',
                '如果不習慣口頭表達，可以拍下魚缸照片配上一句描述發送給主管，書面溝通同樣有效',
                '每天結束護理工作前，用兩至三句話向主管匯報當天所有魚缸的水質狀況和魚隻情況',
                '聽到護理指示但不完全理解時，說：「我想確認一下，你的意思是＿＿，然後我需要＿＿，對嗎？」',
                '描述魚隻問題時，用具體事實，例如「3號魚缸有兩條魚在水面附近游動，已持續約二十分鐘」',
                '記住你在魚缸旁的觀察是主管無法隨時親眼看到的第一手資訊，每次準確的匯報都很重要',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員的溝通需求是農場四個崗位中最多樣和複雜的，需要向主管匯報農場整體狀況、向多個崗位傳達協調指示，以及在某些情況下與外部買家進行業務溝通。相比理想狀態，你目前在主動清晰地與多個不同對象進行農場運作相關溝通方面仍有差距，可能影響農場各崗位的協調效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '根據不同溝通對象準備不同固定句式：向主管匯報用「今天農場狀況是＿＿，收成進度是＿＿，需要你決定的事項是＿＿」',
                '向同事傳達協調需求時，使用「我需要你在＿＿時間幫忙＿＿，大概需要＿＿分鐘，你可以嗎？」讓協作請求清晰具體',
                '傳達重要農場資訊時，優先使用具體數字而非模糊形容：例如「今天完成了八十公斤番茄的收割和六十包的包裝」',
                '建立每天與主管的固定溝通時間，例如工作開始前五分鐘確認當天重點，工作結束前五分鐘匯報完成情況和需要跟進的事項',
                '需要向多個崗位同事傳達同一資訊時，考慮用書面方式（例如白板或訊息）確保每個相關人員收到相同的資訊',
              ],
            },
          ],
        },
        {
          // Strong physical skills
          abilityName: '體能強健',
          displayName: '體能強健',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作需要搬運設備零件（如水泵、管道）、在不同位置彎腰蹲下進行檢查，以及長時間站立或步行於農場各區域之間。相比理想狀態，你目前的體能水平及長時間持續體力勞動的耐力仍有一定差距，可能影響你完成體力任務的效率及在工作中保持安全操作的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入簡單運動，例如每天步行30分鐘或做深蹲，慢慢提升農場工作所需體力',
                '每天上班前做五至十分鐘熱身，例如伸展背部和手腕，準備好進行彎腰蹲下的維修工作',
                '搬運水泵或管道等設備時，記住屈膝蹲下、背部挺直、靠近物件才舉起，不要用腰部發力',
                '某項搬運任務超出體力範圍時，立即告訴主管或請同事幫忙，不要勉強自己獨自完成',
                '每隔一至兩小時休息五分鐘並喝水，避免體力透支影響維修工作的準確性和安全',
                '感到頭暈、肌肉異常痠痛或呼吸困難時，應立即停止工作並告知主管，不要繼續強撐',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員每天需要長時間蹲下或彎腰播種、搬運種植介質及手持工具修剪，對肌肉耐力和持續體力有一定要求。相比理想狀態，你目前的體能水平及維持一整天種植工作體力的能力仍有差距，可能影響工作效率及後段工作的操作安全性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入簡單體能練習，例如每天步行30分鐘或做基本深蹲和背部伸展，提升種植工作所需體力',
                '每天上班前做5至10分鐘暖身，伸展背部、大腿及手腕，為需要蹲低和彎腰的播種工作做好準備',
                '搬運種植托盤或培植土時，記住屈膝蹲下、背部挺直、靠近物件才提起，不要用腰部發力',
                '某個搬運任務超出你能安全應付的重量時，立即告知主管或請同事協助，不要勉強獨自完成',
                '每隔一至兩小時休息五分鐘並補充水分，讓肌肉短暫恢復，防止疲勞影響後段工作的動作質素',
                '感到頭暈、手部顫抖、腰部持續疼痛或呼吸急促時，立即停止工作並告知主管',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師需要長時間站立於魚缸旁餵飼和觀察、搬運飼料袋或水桶、彎腰清潔魚缸底部，以及在魚缸之間來回步行，對肌肉耐力和整體體力有持續要求。相比理想狀態，你目前的體能水平及在一整天魚類護理工作中維持體力的能力仍有差距，可能影響工作後段的操作準確性和安全性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入簡單運動，例如每天步行30分鐘或做基本深蹲，慢慢提升長時間站立和搬運所需的體力',
                '每天上班前做五至十分鐘熱身，例如伸展背部和腿部肌肉，讓身體準備好今天在魚缸旁的工作',
                '搬運飼料袋或水桶時，記住屈膝蹲下、背部挺直、靠近物件才舉起，不要用腰部發力傷害自己',
                '某項搬運任務超出體力範圍時，立即告訴主管或請同事幫忙，不要勉強自己獨自完成任務',
                '每隔一至兩小時休息五分鐘並喝水，避免因長時間站立和搬運而導致體力透支影響工作安全',
                '感到頭暈、肌肉異常痠痛或呼吸困難時，應立即停止工作並告知主管，不要繼續強撐',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員的體能需求是農場中最全面和多樣的，同一天內可能需要彎腰收割、搬運收成箱、長時間站立包裝及搬運噴灑設備，特別是在收成高峰期工作量會大幅增加。相比理想狀態，你目前的整體體能水平及在一整天多樣體力工作中維持穩定表現的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中建立基礎體能訓練習慣，包括每天步行三十分鐘提升心肺耐力、每週做深蹲和核心肌群訓練，增強收割和搬運所需的體力',
                '每天上班前做八至十分鐘全身熱身運動，覆蓋背部、肩膀、手腕、膝蓋和腳踝，為全天多樣性高的體力工作做好準備',
                '搬運裝有農產品的收成箱時，屈膝蹲下、背部挺直、把收成箱貼近身體才提起，若重量超出安全範圍，立即分拆或請同事協助',
                '在收成高峰期等高強度工作時段，與主管商定合理的工作休息節奏，例如每完成固定數量搬運後休息五分鐘補充水分',
                '學習辨識自己在不同類型體力工作中的體能消耗模式，根據自己的體能規律安排一天中最消耗體力的工作時段',
              ],
            },
          ],
        },
        {
          // Enjoys hands-on work
          abilityName: '喜愛實地操作工作',
          displayName: '喜愛實地操作工作',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護的核心是動手實務操作，例如安裝及調較灌溉設備、更換損壞的管道接頭及測試水質感應器。相比理想狀態，你目前對動手實務操作的興趣及主動嘗試的意願仍有一定距離，可能影響你在農場現場的學習速度、工作效率及整體投入感。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '接觸新設備或維修工具前，先請主管示範完整操作步驟，清楚了解程序後再自己嘗試',
                '為自己設定每天的小目標，例如「今天學會獨立更換一個水管接頭」，完成後給自己肯定',
                '某個維修操作讓你感到不舒服時，提前告訴主管，一起想想有沒有其他更適合的方式',
                '把每次動手維修當成學習機會，做錯了沒關係，重要的是知道正確的維修步驟是什麼',
                '把每種設備的操作和維修步驟記在筆記本裡，下次做同樣工作時，對著筆記操作更有信心',
                '主動向主管要求參與更多維修任務，從簡單的設備保養開始，逐步嘗試更複雜的維修工作',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員的工作是高度動手的田間操作，包括逐粒播種、移植幼苗及修剪枝葉。相比理想狀態，你目前對動手田間工作的興趣及主動嘗試的意願仍有差距，可能影響你在田間操作時的專注度及對種植工作整體的投入感。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '開始新的田間操作前，先請主管或同事完整示範一次，清楚了解每個步驟的動作要領後再自己嘗試',
                '為自己設定每天一個具體小目標，例如「今天把這一格育苗盤全部播種完」，讓每次動手工作有完成點',
                '接觸某些種植材料（例如泥土或肥料）讓你感到不舒適時，可以佩戴手套，並告知主管共同研究方法',
                '把每次動手種植視為觀察植物的機會，例如移植幼苗時留意根部形狀，修剪時觀察植物生長方向',
                '建立一本「操作記錄本」，把每種種植任務的步驟寫下來，下次執行同樣任務時對照使用',
                '主動向主管要求參與不同種植任務，從最基本的播種開始，逐步嘗試移植和修剪等較複雜的操作',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師每天需要親手量取飼料、操作水質測量儀器、清除魚缸壁藻類、清洗過濾設備，以及在必要時用網捕撈魚隻。相比理想狀態，你目前對親手進行魚類護理操作的興趣及主動嘗試的意願仍有差距，可能影響你操作設備時的熟練程度及整體投入感。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '接觸新的魚類護理操作或設備前，先請主管示範完整步驟，包括安全注意事項和常見錯誤，了解清楚後再嘗試',
                '為自己設定每天一個小目標，例如「今天學會獨立操作水質測量儀器並記錄數據」，完成後給自己肯定',
                '某個護理操作讓你感到不舒服時（例如接觸藻類或過濾器沉積物），可以使用手套，並告知主管共同找方法',
                '把每次動手護理操作當成了解魚類的機會，例如餵飼時觀察不同魚的進食反應，讓操作更有意義',
                '建立一本「魚類護理操作記錄本」，把每種設備的操作步驟寫下來，下次操作時對照使用更有信心',
                '主動向主管要求參與更多不同類型的護理操作，從最基本的餵飼和記錄開始，逐步嘗試更複雜的操作',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員的動手操作種類在農場中最為多樣，包括收割、操作包裝設備、調配蟲害防治噴灑設備，以及維護農場基礎設施。相比理想狀態，你目前對多樣性高的農場動手實務操作的興趣及主動學習新操作技能的意願仍有差距，可能影響你在不同農場工作中的操作熟練度。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '為自己制定一個「技能學習進度表」，列出這個崗位涉及的所有主要操作技能（收割技術、包裝操作、噴藥程序、基本維修），每掌握一項就標記，讓自己看見進度',
                '接觸任何新的農場操作工具或設備前，主動請主管進行完整示範，包括正確使用方法、安全注意事項和常見操作錯誤',
                '把每種農場操作視為有深度可探索的技術，例如學習收割技術時，不只學「怎樣切」，同時了解「在哪個位置切最有利於植物持續生長」',
                '完成每種新的農場操作後，主動向主管尋求反饋：「我今天的操作有沒有什麼地方可以改進？有更有效率的方式嗎？」',
                '主動向主管要求參與更多不同類型的農場操作任務，從簡單的設備保養開始，逐步嘗試更複雜的收割和蟲害防治操作',
              ],
            },
          ],
        },
        {
          // Environment endurance
          abilityName: '環境耐受能力',
          displayName: '環境耐受能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場維護環境多變且具挑戰性，員工可能需要在高溫潮濕的溫室內工作，接觸水、泥土及農業氣味，並面對噪音與強光等感官刺激。相比理想狀態，你目前對農場工作環境中各種感官刺激的耐受能力仍有一定差距，可能導致工作期間感到疲憊、焦慮或難以集中注意力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '上班前先了解今天的工作環境，例如溫室溫度或是否需要接觸水，提前做好心理準備',
                '準備好適合的個人裝備，例如防水手套、防滑鞋和耳塞（用於嘈吵的水泵旁），減少不適',
                '農藥氣味或潮濕環境讓你特別不舒服時，提前告訴主管，探討是否可以調整工作安排',
                '試試「短時間接觸、逐步適應」的方法，先在溫室環境中工作15分鐘，再慢慢增加時間',
                '為自己設立固定的「休息位置」，例如溫室外的安靜位置，感到不適時去那裡短暫調整',
                '學習辨識自己感官不適的早期訊號，例如開始感到煩躁或頭痛，在情況加劇前主動休息',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員的工作環境包括戶外農田和潮濕溫室，員工需要接觸泥土、肥料氣味及面對強光和風吹等感官刺激。相比理想狀態，你目前對種植工作環境中各種感官刺激的耐受能力仍有差距，可能影響你在某些天氣條件下維持穩定工作表現的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '上班前了解今天的工作地點和天氣，預先知道要在溫室還是戶外工作，有助減低突如其來的不適感',
                '根據當天環境配備適合裝備：晴天戴遮陽帽，潮濕天穿防水外套，施有機肥料時佩戴手套和口罩',
                '特定氣味（例如有機肥料）令你不適時，告知主管你的需要，共同研究是否可以調整任務安排',
                '採用「短時間接觸、逐步適應」的方式：第一次在溫室工作時，先待15分鐘，再慢慢增加時間',
                '為自己建立固定的「恢復時刻」：每隔一段時間走到陰涼通風的地方，花幾分鐘安靜地調整感官',
                '學習辨識自己的感官預警訊號，例如開始感到煩躁或難以集中，在情況加劇前主動採取行動',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師長時間在魚缸旁工作，需要持續接觸高濕度空氣、魚缸的特有氣味、水泵的低頻背景噪音，以及清潔魚缸時的水溫差異，這些環境刺激可能引發感官不適。相比理想狀態，你目前對魚類護理工作環境中各種感官刺激的耐受能力仍有差距，可能影響你維持穩定工作表現的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '上班前先了解今天的工作安排，例如是否需要深度清潔魚缸或換水，讓自己提前對感官環境有心理準備',
                '準備好適合的個人裝備：對水腥味敏感可在清潔時佩戴口罩，對持續噪音困擾可使用耳塞（確保能聽到指示）',
                '採用「短時間接觸、逐步適應」策略：初期在魚缸區域工作時，先工作30分鐘，再慢慢延長時間',
                '在魚缸工作區域附近設立個人「調節空間」，感到感官過度刺激時，到那裡短暫休息三至五分鐘',
                '學習辨識自己的感官預警訊號，例如開始感到難以集中或情緒波動，在訊號出現早期就主動採取行動',
                '若某種感官刺激對你造成持續困難，主動與主管坦誠溝通，共同探討是否有工作安排調整的可能性',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員面對的感官環境是農場中最複雜和多變的，同一天內可能需要應對戶外強烈陽光、溫室高濕度、蟲害防治化學農藥氣味，以及農場巡查時不同區域的感官環境切換。相比理想狀態，你目前在一天內跨多個感官環境持續工作及維持穩定表現的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天開始工作前，確認當天需要面對哪些不同的感官環境，例如今天是否需要蟲害防治或大量溫室包裝工作，提前對全天感官環境有心理準備',
                '為每個主要感官挑戰建立個人應對工具包：應對強烈陽光備好寬邊遮陽帽和防曬衣，應對農藥氣味備好高效過濾口罩，應對護目鏡不適選擇適合臉型的型號',
                '與主管商討是否可以把感官刺激最強烈的工作環節（例如蟲害防治噴灑）安排在感官較舒適的工作環節之後，讓感官系統提前充分準備',
                '在每個感官環境較具挑戰性的工作環節結束後，給自己固定的「感官恢復時間」，例如完成蟲害防治後在通風位置休息五至十分鐘',
                '學習識別自己在各個感官環境中的個人耐受極限，在接近極限之前主動要求短暫休息，而不是等到感官系統已超負荷才行動',
              ],
            },
          ],
        },
        {
          // Body coordination
          abilityName: '身體協調能力',
          displayName: '身體協調能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護需要在狹窄管道空間中使用工具進行精準操作、雙手同時處理零件與螺絲，並在不平坦或濕滑的農場地面上保持身體平衡。相比理想狀態，你目前的身體協調能力及動作精準度仍有一定差距，可能影響你在使用工具時的準確性、工作速度及操作安全性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入簡單協調練習，例如用筷子夾細小物件，幫助訓練維修工作所需的手眼協調',
                '使用工具前，先在穩定平面上練習相關動作，例如擰螺絲或接合管道，熟悉手感後再實際操作',
                '在農場地面移動時放慢速度，特別是在有水漬或不平坦的地方，安全永遠比速度重要',
                '需要在狹窄管道空間或高處進行維修時，告訴主管並要求有人在旁協助確保安全',
                '工作時保持雙腳穩定站立、重心置中，避免在進行維修操作時過度伸展或扭曲身體',
                '某個維修動作對你特別困難時，告訴主管，一起研究是否可以用輔助工具幫助完成',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員的核心操作對身體協調有具體要求，例如精準夾取細小種子、一手固定幼苗同時另一手填土，以及在不平坦的種植床間保持平衡。相比理想狀態，你目前的手眼協調及動作精準度仍有差距，可能影響種植操作的準確性及田間移動的安全性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入提升手部精細動作的練習，例如用筷子夾取細小物件，訓練播種所需的手指靈活性',
                '在農場實際操作前，先在桌面練習基本種植動作，例如用手指拿取細小豆子放入容器，熟悉觸感和力度',
                '播種時不要急，給自己足夠時間逐粒處理，準確把種子放入正確位置比速度更重要',
                '移植幼苗時，選擇穩定舒適的站姿或蹲姿再開始，避免在身體不穩定的情況下同時處理幼苗',
                '在田間步行時，放慢步伐，專注看清楚每一步的位置，特別是在種植床窄道或雨後濕滑地面',
                '某個動作對你特別困難時，告訴主管，共同研究是否有更適合的工具或操作方式幫助你完成',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師的多項操作對身體協調有具體要求，例如用網捕撈魚隻時需要手眼協調、操作水管和閥門時需要雙手協調，以及在濕滑的魚缸周邊環境中保持身體平衡。相比理想狀態，你目前的手眼協調及整體動作控制能力仍有差距，可能影響護理操作的準確性及在濕滑環境中的人身安全。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入提升手眼協調的練習，例如用筷子夾取細小物件，幫助訓練魚類護理操作所需的手部控制',
                '在實際執行操作前，先在靜止環境中練習相關動作，例如在空魚缸或水桶中練習用網撈取物品',
                '使用網捕撈魚隻時，動作要緩慢而穩定，不要因為魚游動而急速揮動網，給自己時間觀察魚的游動規律',
                '在魚缸旁工作時，保持雙腳分開與肩同寬、重心置中，在潮濕或濕滑地面上放慢移動速度',
                '若某個操作對你的協調能力構成特別大挑戰，例如同時控制水管和閥門，先請主管示範慢動作再練習',
                '記住身體協調能力是可以通過重複練習逐步改善的，不需要一開始就做到完美，每次練習都是進步',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員的身體協調需求涵蓋多種動作技能，包括收割時的手眼協調、操作包裝設備時的雙手協調、蟲害防治噴灑時的穩定控制，以及在不平坦地面搬運收成箱時的身體平衡。相比理想狀態，你目前的手眼協調及整體動作控制能力在面對多樣農場操作時仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在日常生活中加入針對手眼協調和整體動作控制的練習，例如練習用非慣用手執行簡單任務，提升雙手的均衡協調能力',
                '學習每種農場操作工具時，先在靜止的環境中練習基本動作，例如在工作台上練習收割剪刀的準確切割角度，熟悉後再在農場實際植株上操作',
                '收割工作時，培養「先停、再看、後切」的操作節奏，每次下刀前先停頓一秒確認切割位置是否正確，再緩慢準確地執行',
                '操作蟲害防治噴灑設備前，先在非種植區域試噴一次，確認噴嘴角度和力度符合預期，再進入種植區域正式噴灑',
                '在農場環境中移動時，特別是搬運收成箱時，保持「慢而穩」的移動原則，視線保持在前方地面，提前識別不平坦或濕滑區域',
              ],
            },
          ],
        },
        {
          // Loves plants and fish
          abilityName: '喜愛植物與魚類',
          displayName: '喜愛植物與魚類',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護工作需要每天觀察植物的生長狀態、留意魚類的行為與健康情況，以及監測水質是否適合生命生存。相比理想狀態，你目前對植物與魚類的興趣及連結感仍有一定距離，可能影響你在日常觀察中的主動性、發現異常的敏感度及對農場生態的整體投入感。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '從認識農場中種植的蔬菜品種和養殖的魚類開始，了解它們的名稱、外觀和基本習性',
                '每天在系統巡查時，花兩至三分鐘觀察植物生長狀態和魚類的游動行為，記錄下來',
                '為自己訂立一個「維護目標」，例如「這星期確保所有魚缸水質保持在正常範圍內」',
                '對植物或魚類狀態有疑問時，主動問種植技術員或生態照護導師，把問題變成學習機會',
                '在休息時間瀏覽農業或魚菜共生相關的短片或資訊，建立對農場生態的認識與興趣',
                '記住你維護的水循環系統，直接影響植物和魚類能否健康成長，這份責任很有意義',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員的工作核心是親手培育植物生長，需要對植物抱有真實的關注與好奇心。在魚菜共生農場中，植物健康與魚類生長環境也是緊密相連的。相比理想狀態，你目前對植物及農場生命的連結感與興趣仍有差距，可能影響你主動觀察植物狀態的習慣及整體投入感。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '從認識你每天種植的品種開始，了解它們的名稱、生長特性、適合的溫度和水分需求',
                '每天選一株植物，花兩至三分鐘仔細觀察葉片顏色、莖部狀態和整體形態，把觀察記在筆記本上',
                '嘗試為自己「認養」農場中的一個種植區域，把這個區域的植物視為自己負責照顧的生命',
                '向主管或同事請教一個你感到好奇的問題，例如「為什麼這批菜長得比那批快？」用好奇心驅動學習',
                '在休息時間瀏覽關於植物種植或魚菜共生農業的短片或資訊，累積對農場生態的認識與興趣',
                '記住你每天播下的每一粒種子，都將長成農場出產的食物，你的雙手直接參與了生命的成長過程',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '對生態照護導師而言，對魚類的真實興趣和關愛是這份工作的核心驅動力。魚類是魚菜共生農場整個生態系統的核心，牠們的健康直接影響植物的生長。相比理想狀態，你目前對魚類及農場生命生態的連結感與興趣仍有差距，可能影響你主動留意魚隻細微狀態變化的習慣及整體投入感。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '從認識你每天護理的魚類品種開始，了解它們的名稱、自然習性、喜歡的水溫和健康時的典型游動方式',
                '每天選一個魚缸，花三至五分鐘安靜地觀察魚隻的行為，例如餵飼前後的游動模式有什麼不同',
                '嘗試為農場中的某幾條魚建立個別「魚隻觀察記錄」，記下外觀特徵、習慣行為和健康狀況',
                '向主管或有經驗的同事請教一個你感到好奇的問題，例如「這批魚在不同時間的游動深度為什麼不同？」',
                '在休息時間瀏覽關於魚類養殖或魚菜共生農業的短片或資訊，建立對魚類護理工作的認識與興趣',
                '記住你每天細心提供的飼料和護理，是每一條魚能夠健康成長的直接原因，這份責任值得珍視',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員與農場生命生態的互動，主要是從整體運作管理的角度出發，例如收割時判斷農作物成熟程度、病蟲害防治時識別植物受害跡象，以及巡查時留意農場整體生態健康。相比理想狀態，你目前對農場植物和魚類生態的興趣及整體連結感仍有差距，可能影響農場巡查時的觀察敏感度。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '從理解農場植物和魚類的相互依存關係開始：了解魚類代謝物如何成為植物養分，把魚菜共生農場視為一個完整的生命生態系統',
                '在每天的農場巡查中，把對植物和魚類的觀察納入固定巡查項目，例如巡查種植區時，同時留意植物整體生長狀態是否健康',
                '在進行收割工作時，培養對農作物的欣賞視角：一株達到收割標準的植物，代表著種植技術員每天細心護理的成果',
                '在病蟲害防治工作中，把識別植物受害跡象視為保護農場生命的行動，讓這份保護責任感成為你在蟲害巡查中保持細心的動力',
                '向種植技術員和生態照護導師主動請教，了解他們每天觀察到的植物和魚類狀態，從直接護理人員的視角學習如何更好地理解農場生命健康',
              ],
            },
          ],
        },
        {
          // Understand life cycle
          abilityName: '了解生命週期',
          displayName: '了解生命週期',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '了解植物與魚類的生命週期，是判斷農場狀態是否正常的重要基礎，例如掌握不同蔬菜的生長週期、魚類在不同階段的飼料需求，以及植物出現特定症狀時應採取的行動。相比理想狀態，你目前對動植物生命週期的掌握程度仍有一定差距，可能影響異常識別及系統調整的時機判斷。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '向主管索取農場各品種的生命週期簡表，貼在維修工作區域顯眼位置，方便隨時查閱',
                '為每批植物或魚類建立「生長追蹤記錄」，記下種植或入缸日期和每次觀察到的狀態',
                '學習辨識三個重要轉變點：幼苗期到生長期、幼魚期到成魚期，以及接近收成期的特徵',
                '發現植物或魚類狀態與記錄不一樣時，立即記下差異並告訴主管，不要忽視或等待',
                '每週深入了解一種植物或一種魚的生命歷程，把生命週期知識應用到日常維護決定上',
                '例如魚進入成魚期時，主動確認水質系統設定是否需要調整，讓知識直接指導維護工作',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '了解植物的生命週期是種植技術員判斷工作是否正確的核心基礎，從種子萌芽、幼苗生長到收割，每個階段都有不同的護理需求。相比理想狀態，你目前對農場種植品種生命週期的了解程度仍有差距，可能影響你識別異常情況及作出適時護理決定的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '向主管索取農場各個種植品種的生命週期簡介，了解從播種到收割需要多少天及各階段主要特徵',
                '為每批播種的植物建立「生長追蹤表」，記下播種日期、預計各階段到達時間及每次巡查的觀察結果',
                '學習辨識三個關鍵的生命週期轉變點：種子發芽的特徵、幼苗準備好移植的狀態、植株接近收割的標誌',
                '每次發現植物狀態與預期不符時，例如發芽比預期慢，立即記錄並向主管匯報，共同判斷是否需要調整',
                '把生命週期知識與每日護理連結：例如知道植物今天進入生長期，主動詢問施肥時間和份量是否需要調整',
                '不需要一次記住所有品種的生命週期，每週深入了解一個品種，讓每週都成為一次有目標的學習機會',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '了解魚類的生命週期是生態照護導師作出正確護理決定的重要基礎。從魚苗孵化、幼魚生長、成魚發育到收成，每個階段都有不同的飼料需求、水質要求和疾病風險。相比理想狀態，你目前對魚類生命週期的掌握程度仍有差距，可能影響你判斷護理方式是否符合魚隻當前生長需求的能力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '向主管索取農場養殖魚類的生命週期簡介，了解從魚苗到成魚各階段的特徵、飼料需求和水質要求',
                '為每批魚苗或新入缸的魚建立「生長追蹤記錄」，記下入缸日期、預計各生長階段時間及每次護理巡查的觀察',
                '學習辨識三個關鍵轉變點：魚苗期到幼魚期的變化、幼魚期到成魚期的外觀和食量變化，以及接近收成的特徵',
                '發現魚隻生長進度與預期有明顯差距時，例如體型明顯偏小，立即記錄並告知主管，共同評估是否需要調整護理',
                '把生命週期知識和每天護理決定連結：例如魚隻進入成魚期時，主動確認飼料份量和水質設定是否需要調整',
                '不需要一次記住所有品種的生命週期，每週深入了解一個生長階段，慢慢積累魚類護理知識',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要從農場整體運作管理角度了解植物和魚類的生命週期，例如了解不同農作物從種植到收割的時間，是制定收成計劃的基礎；了解植物不同生長階段對蟲害的抵抗力差異，有助確定防治的優先時機。相比理想狀態，你目前對生命週期的掌握及在收成管理中的應用能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '建立一份「農場品種生命週期概覽表」，涵蓋農場目前種植的所有農作物品種和養殖魚類，記錄每個品種的收成時間、各關鍵生長階段特徵及收成後最佳處理時限',
                '從收成管理角度學習識別農作物的最佳收割時機，與主管和種植技術員確認每個品種的收割標準，包括顏色、大小、硬度等具體指標',
                '了解植物在不同生命週期階段的蟲害風險差異，例如幼苗期和開花期通常是最容易受蟲害侵害的時期，把這種知識應用到蟲害防治的時間安排上',
                '學習了解農產品在收割後的品質變化規律，例如不同農作物在常溫下可以保持最佳品質的時間，直接影響包裝工序和交付時間的安排',
                '定期與種植技術員和生態照護導師交流，了解目前農場各批次植物和魚類所處的生長階段，提前預計哪個週期將迎來收成高峰',
              ],
            },
          ],
        },
        {
          // Persistence & resilience
          abilityName: '具備耐性',
          displayName: '具備耐性',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護的日常巡查、設備保養及生態監測工作重複性高，且成效不會立即可見。這份工作需要員工在普通的日子裡也能保持一致的專注與行動力。相比理想狀態，你在面對此類任務時維持持續投入的能力仍有一定差距，可能導致工作連貫性下降或在遇到困難時較易放棄。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的系統巡查和設備保養工作分解成具體清單，每完成一項就打剔，看見工作進展',
                '為自己設定每週小目標，例如「這週連續七天按時完成早上的水質測量記錄」，一步步堅持',
                '建立固定工作節奏，例如每天在同一時間巡查同一設備區域，讓維護任務變成熟悉的習慣',
                '維護工作感到沉悶時，為自己加入小觀察挑戰，例如「今天留意水泵聲音有沒有細微變化」',
                '遇到維修困難時先停下來，把問題寫下來告訴主管，把困難視為需要解決的事而非放棄理由',
                '定期回顧自己的維護記錄，看看農場系統在你持續維護下有什麼改善，看見堅持的價值',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植工作的成果往往不是即時可見的，播種後可能需要數天才能看到發芽，整個生長周期可能長達數週。相比理想狀態，你目前在面對成效不立即可見的重複性種植工作時，維持持續投入與穩定性的能力仍有差距，可能導致某些護理步驟被省略或較易放棄。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的種植護理任務整理成清單，每完成一項就打剔，讓完成清單本身成為每天可見的成就',
                '為自己設定以「行動」為基礎的短期目標，例如「這週連續七天按時完成早上的澆水和巡查」',
                '建立固定的每日工作節奏，例如每天在同一時間以相同順序執行種植任務，讓工作成為熟悉的習慣',
                '每天結束工作前，花一兩分鐘回顧今天觀察到的植物狀態，把微小的進步記錄下來，看見持續工作的累積效果',
                '某天感到枯燥或缺乏動力時，先把最基本的任務完成，例如澆水和記錄，小步前進比完全停下要好',
                '記住農場中每一批健康成長的農作物，都是每一天細心護理的累積成果，堅持做好每個步驟很重要',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類護理工作需要長期、穩定而不間斷的投入，餵飼不能因感到乏味而跳過，水質監測不能因數據正常而放鬆，魚缸清潔不能因看起來乾淨而延後。相比理想狀態，你目前在面對高度重複的魚類護理任務時維持長期穩定投入的能力仍有差距，可能導致某些護理步驟被省略或工作標準出現波動。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的魚類護理任務整理成完整清單，每完成一項就打剔，讓完成清單本身成為每天都能看見的成就',
                '為自己設定以「行動一致性」為基準的短期目標，例如「這週連續七天在規定時間內完成所有護理任務」',
                '在感到乏味或動力不足的日子，把護理任務分解成最小的可執行單位，例如「現在只需要完成這個魚缸的餵飼」',
                '建立定期回顧魚隻生長數據和水質記錄的習慣，讓自己看見持續穩定護理工作帶來的累積效果',
                '某天感到特別難以維持投入時，完成最基本的護理任務（餵飼、水質記錄）後，告知主管你的狀態請求支持',
                '記住對魚隻而言，今天的護理和明天的護理同樣重要，沒有任何一天的護理是可以例外的',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要在高壓的收成高峰期維持穩定工作標準，以及在蟲害反覆出現或農場設施持續出現問題時，保持解決問題的意志和耐力。相比理想狀態，你目前在高強度工作時段維持穩定表現及面對反覆出現問題保持解決問題意志的能力仍有差距，可能影響農場最需要穩定輸出時期的運作質素。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在收成高峰期等高強度工作時段，與主管提前制定清晰的工作節奏計劃，包括每個工作段落的目標完成量、休息時間安排，以及不同崗位同事之間的協作分工',
                '當面對反覆出現的農場問題時，例如蟲害在防治後短期內再次出現，把每次問題再次出現視為收集更多資訊的機會，分析這次和上次有什麼規律差異',
                '在農場整體運作壓力較大的時期，把需要跟進的工作分解成每天可以完成的小步驟，例如「今天只需要完成蟲害防治區域的更新記錄」',
                '建立「工作成果可視化」習慣，例如在收成高峰期，每完成一批農作物的收割和包裝，在記錄表上標記完成數量，讓自己看見努力的累積',
                '感到工作壓力過大或意志力接近極限時，主動與主管溝通目前的工作狀態，請求資源支援或工作調整，及時尋求支持是負責任的表現',
              ],
            },
          ],
        },
        {
          // Passionate
          abilityName: '充滿熱誠',
          displayName: '充滿熱誠',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '對農業生態與系統運作的熱誠，是驅動員工在農場維護工作中持續成長的重要動力。有熱誠的員工會主動留意細節、對改善方法感到好奇。相比理想狀態，你目前對這份工作的熱誠與主動投入程度仍有一定差距，可能影響學習動力、工作質素及面對挑戰時的持續改進意願。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '找出農場維護工作中你覺得最有趣的環節，例如水質數據的變化或設備運作的原理',
                '每天完成工作後，問自己「今天我對農場系統有什麼新的了解？」把小發現記錄下來',
                '主動向主管提出一個你好奇的問題，例如「這個水泵的設計有什麼特別的原因嗎？」',
                '農場系統出現問題時，先試試自己分析可能的原因，再和主管討論，讓自己更投入工作',
                '在工作以外接觸農業或魚菜共生相關資訊，例如觀看相關短片，讓工作與更大的世界連結',
                '記住熱誠是可以慢慢建立的，每天認真維護好農場系統，就是建立熱誠最踏實的方式',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植工作充滿值得深入探索的細節，對種植抱有熱誠的人會主動思考、學習，並在遇到問題時積極找出原因。相比理想狀態，你目前對種植工作所展現的熱誠與主動投入程度仍有差距，可能影響你的自主學習意願及面對種植挑戰時繼續前進的動力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '找出種植工作中你覺得最有趣的一個環節，例如觀察種子發芽或留意施肥後植物的變化，以此作為動力',
                '每天完成工作後問自己：「今天我注意到了什麼新的東西？」就算只是細小觀察，也把它記下來',
                '主動向主管提出一個種植相關的問題，例如「為什麼我們選擇這個品種？」把好奇心轉化為學習對話',
                '種植出現問題時，不要只等待主管處理，先自己想一下可能的原因，再與主管討論，讓自己更投入工作',
                '在工作以外接觸農業相關資訊，例如了解本地農業發展或觀看不同種植方法的短片，擴闊種植視野',
                '記住熱誠不是必須天生就有的感覺，通過了解、嘗試和看見自己的努力帶來成果，熱誠可以慢慢建立',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師的工作充滿值得探索的細節，例如為什麼同樣的飼料份量，某批魚的生長速度比另一批快？對魚類護理抱有熱誠的員工會主動學習、觀察和尋找改善方法。相比理想狀態，你目前對魚類護理工作所展現的熱誠與主動投入程度仍有差距，可能影響你的自主學習意願及面對護理挑戰時的動力。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '找出魚類護理工作中你覺得最有趣的一個環節，例如觀察魚隻在餵飼前後的行為差異，以此作為每天的動力',
                '每天完成護理工作後，問自己「今天我對這些魚隻有什麼新的了解？」把小發現記錄在筆記本上',
                '主動向主管提出一個你感到好奇的問題，例如「為什麼這批魚在不同水溫下的進食積極性會有那麼大的差異？」',
                '當魚缸出現問題時，先試試自己分析可能的原因，再和主管討論，這樣會讓你對護理工作更加投入',
                '在工作以外接觸水產養殖或魚菜共生農業相關資訊，例如觀看相關短片，讓工作與更廣闊的農業世界連結',
                '記住熱誠是可以慢慢建立的，每天認真護理好每一條魚，就是建立熱誠最踏實的方式',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '農場營運與收成管理工作表面上是一系列管理任務，但真正投入的員工能看到更大的意義：每次成功收割代表農場生態系統的完整循環，每批高品質農產品代表農場努力轉化為成果。相比理想狀態，你目前對這份工作所展現的熱誠與主動投入程度仍有差距，可能影響你主動尋找改善農場運作的意願。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '找出農場營運管理工作中你覺得最有意義或最有成就感的一個環節，例如看到高品質農產品完整完成收割到包裝的全程，以此作為每天工作熱誠的起點',
                '每天工作結束後，花三分鐘回顧今天農場運作中有什麼進展或改善，哪怕只是「今天的包裝流程比昨天少用了十分鐘」，讓自己每天看見工作的正面影響',
                '主動向主管表達你對農場運作改善的想法，例如「我觀察到包裝工序的某個步驟可能有更有效率的方法，可以和你討論嗎？」讓熱誠通過具體建議表現出來',
                '在與種植技術員和生態照護導師的日常協作中，主動了解他們的工作和挑戰，讓對其他崗位工作的了解轉化為對農場整體生態更深的連結',
                '在工作以外接觸農業和可持續農業相關資訊，例如了解魚菜共生農業在全球的發展，讓工作與更廣闊的農業世界連結，看見這份工作更大格局的意義',
              ],
            },
          ],
        },
        {
          // Problem solving
          abilityName: '解難能力',
          displayName: '解難能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護的日常運作中經常出現突發情況，例如水流異常、管道堵塞、設備故障或水質失衡，這些問題往往需要透過觀察和分析才能找出根本原因。相比理想狀態，你目前在分析問題及結構性思考方面仍有提升空間，可能影響處理突發情況的效率、信心及判斷的準確性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把複雜的設備問題分拆成小步驟，例如先確認故障現象，再逐步分析可能的原因',
                '建立簡單的問題處理流程，例如「觀察現象→分析原因→測試解決方法→確認修復」',
                '把常見的設備問題和處理方法記在筆記本裡，下次遇到類似情況時可以對照參考',
                '在日常維護中，試著問自己「這個問題為什麼會發生？」而不只是「我應該怎樣修復它？」',
                '向有經驗的同事或主管學習解決設備問題的方法，把好的方法記下來，慢慢變成自己的能力',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員在田間工作時，會定期遇到需要即時處理的問題，例如植物發芽率低、灌溉系統滴漏或葉片出現異常斑紋。相比理想狀態，你目前在田間識別問題、分析可能原因及採取適切行動方面仍有差距，可能導致問題被忽略或處理延誤，影響種植成果。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管整理一份「常見植物問題對照表」，列出農場常見問題（例如發芽失敗、葉片變色）及建議處理步驟',
                '發現田間異常時，先做三件事：拍照或記錄問題描述、對照問題表、決定是自行跟進還是立即通報主管',
                '學習把植物問題分成兩類：「我可以按程序自行處理的」和「我需要馬上告訴主管的」，清楚兩類的分界',
                '每次與主管處理完一個田間問題後，主動問：「這次問題的根本原因是什麼？我下次應怎樣更早發現？」',
                '思考植物問題原因時，用「如果⋯⋯那麼⋯⋯」逐步推理，例如「如果是缺水，整排都應有問題」縮窄原因',
                '記住在種植工作中，提早發現問題並告知主管，永遠比等問題擴大後才行動要好',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '生態照護導師在日常工作中會遇到需要即時處理的問題，例如水質數據突然超出安全範圍、魚隻出現異常游動或外觀症狀，以及過濾設備故障導致水質迅速惡化。相比理想狀態，你目前在識別魚類護理問題、評估其嚴重性及採取適切行動方面仍有差距，可能影響魚隻得到及時有效保護的機會。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '與主管制定「魚缸問題嚴重程度分級表」，把常見護理問題分成三級：需繼續觀察、需盡快通知主管、需立即緊急行動',
                '發現魚缸異常時，先做三件事：仔細觀察並收集資訊、對照問題分級表評估嚴重程度、再決定行動',
                '描述魚缸問題時，使用具體事實：例如「2號魚缸有三條魚在水面附近游動，溶氧量測量顯示3.5mg/L，低於正常下限」',
                '每次與主管一起處理完一個魚缸護理問題後，問主管：「這次問題的根本原因是什麼？我怎樣可以更早發現？」',
                '思考問題可能原因時，同時考慮多個可能性，例如魚隻進食量下降，可能是水質問題、疾病、水溫變化或飼料質素改變',
                '記住在魚類護理工作中，提早發現問題並告知主管，往往能在問題變嚴重之前把它解決',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要解決的問題類型在農場中最為多樣和複雜，橫跨農場運作的多個層面，例如收割品質未達標準、蟲害防治效果不理想、包裝設備突然故障，以及外部買家提出特殊要求。相比理想狀態，你目前在系統地識別問題根源及評估可行方案方面仍有差距，可能影響農場應對各類運作問題的效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '建立一套適用於農場運作管理的「問題分析框架」，遇到任何農場運作問題時，先回答四個基本問題：問題的具體表現是什麼、最早在什麼情況下出現、有沒有相關因素同時發生、問題是否影響多個區域',
                '學習把農場運作問題按兩個維度分類：緊急程度（需要立即處理還是可以計劃處理）和影響範圍（只影響一個工作環節還是影響農場整體運作）',
                '向主管報告問題時，除了描述問題本身，嘗試同時提出一至兩個你認為可行的解決方案，例如「我認為可以今天下午提前收割這一排，或者先行剔除明顯過熟的果實，你認為哪個更合適？」',
                '建立農場運作問題的「解決方案記錄庫」：每次農場出現問題並找到有效解決方法後，把問題描述、採用的解決方案和結果記錄在一份文件中',
                '培養「從問題中找規律」的思維習慣：如果農場某類問題反覆出現，例如某個季節蟲害特別嚴重，嘗試分析反覆問題背後的共同因素，從事後應對提升到提前預防',
              ],
            },
          ],
        },
        {
          // Learning ability
          abilityName: '學習能力',
          displayName: '學習能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護涉及多方面知識與技能，包括水循環系統原理、設備操作、基礎維修及動植物生長環境的理解，需要透過持續學習與實踐才能逐步掌握。相比理想狀態，你目前在吸收新知識及將學習內容應用於實際工作的能力仍有提升空間，可能影響適應新任務與新設備的速度。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把需要學習的維護知識分拆成小單元，例如先了解水循環系統的基本原理，再學操作細節',
                '試試邊做邊學，把實際維修操作和學到的知識結合起來，這樣會更容易記住和理解',
                '用筆記或流程圖整理學習內容，例如畫出農場水循環系統的結構圖，幫助建立清晰認識',
                '重複練習你覺得困難的維護技能，例如調較水質參數，每次練習都讓你更熟練更有信心',
                '遇到不明白的維護程序，主動向主管或同事請教，不要讓疑問積累，以免影響維護質素',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植環境會不斷變化，不同品種有不同護理需求，農場也會引入新的種植方法，需要員工持續吸收新知識。相比理想狀態，你目前在主動吸收新的種植知識及將所學靈活應用於不同種植情境的能力仍有差距，可能影響你適應新品種或新任務的速度。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每次主管給你新的種植指示時，把關鍵步驟和要點寫在隨身筆記本上，文字記錄比口頭記憶更可靠',
                '養成每天「工作後反思」習慣：工作結束前問自己「今天我學到了什麼？做得好的地方？可以改進的地方？」',
                '農場引入新品種或新種植方法時，主動問主管：「這個品種和之前種的有什麼不同？需要特別注意什麼？」',
                '不要因為害怕做錯而避免嘗試，在主管指導下嘗試新操作，做錯了就問清楚正確方法，然後再試',
                '定期翻看自己過往的工作記錄和觀察筆記，看看自己的種植判斷是否有進步，讓自己看見學習的軌跡',
                '記住種植技術是在田間一次次實際操作中累積的，每次認真完成任務、主動提問，都是在打好技術基礎',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類養殖是一門需要持續學習的領域，不同批次的魚隻有不同的品種特性，水質管理技巧需要隨魚隻生長階段調整，農場也可能引入新的飼料配方或護理方法。相比理想狀態，你目前在主動吸收魚類護理新知識及把所學靈活應用於不同護理情境的能力仍有差距，可能影響你適應新挑戰的速度。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每次主管給你關於魚類護理的新指示時，把關鍵步驟和注意事項寫在隨身工作筆記本上，建立自己的「魚類護理學習記錄」',
                '養成每天「工作後反思」習慣：完成護理工作後問自己「今天我觀察到什麼新的魚類行為或水質現象？」',
                '農場引入新的魚類品種或調整護理程序時，主動問主管：「這個品種和現有的有什麼主要差異？護理上需要特別留意什麼？」',
                '建立「從錯誤中學習」心態：護理操作出現失誤時，主動與主管分析出錯原因，而不是只道歉了事',
                '定期回顧過往的水質記錄和魚隻觀察筆記，嘗試找出規律，例如氣溫上升時哪個水質指標最容易出現偏差',
                '記住在魚類護理工作中，最好的學習來源就是你每天在魚缸旁的親身觀察和操作經驗',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要學習的知識範疇在農場中最廣，從收割技術到蟲害防治化學知識、從包裝衛生標準到農場設施維護技能，需要持續學習並把新知識應用到實際工作中。相比理想狀態，你目前在廣泛的農場運作知識範疇中主動學習及把所學靈活應用於管理決定的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把這個崗位需要掌握的廣泛知識分成若干主題領域，例如收割品質管理、蟲害識別與防治、包裝衛生標準、農場設施基本維護，與主管制定逐步學習的計劃，每個月重點深入學習一個主題',
                '在日常工作中養成「邊做邊學」的習慣，例如進行蟲害防治噴灑時，同時了解使用的農藥針對哪種蟲害、為什麼在這個時間施用、噴灑後多久才能安全進入農場',
                '充分利用農場四個崗位的專業知識，主動向種植技術員學習植物識別，向生態照護導師學習水質管理知識，向系統維護員學習農場設備的基本運作原理',
                '建立一本「農場運作學習筆記本」，把每次從工作經驗、主管指導和跨崗位交流中獲得的新知識記錄下來，並定期回顧',
                '主動尋找農場以外的學習資源，例如了解香港本地農業法規對農產品包裝和標籤的要求，讓工作以外的學習補充和豐富你在農場工作中的實踐知識',
              ],
            },
          ],
        },
        {
          // Observant
          abilityName: '觀察力',
          displayName: '觀察力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護需要持續留意水流變化、設備運作聲音、植物生長狀況及魚類行為等細微變化，這些往往是問題出現前的重要預警訊號。相比理想狀態，你目前在觀察細節、辨識異常及持續監察系統變化方面仍有提升空間，可能導致問題未能及早發現，從而影響整體系統表現。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '建立每日觀察習慣，例如固定在同一時間檢查水流速度、設備運作聲音及動植物的狀態',
                '學習比較「正常狀態」和「異常狀態」的分別，例如正常水流和異常水流聲音的差異',
                '用簡單記錄方式（例如表格或筆記）追蹤每天觀察到的系統變化，方便日後比較分析',
                '在巡查時放慢節奏，不要太急，給自己足夠時間仔細留意設備和生態的每個重要細節',
                '主動思考你觀察到的現象背後可能的原因，例如水流減慢可能是管道堵塞的早期訊號',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員每天巡查植物時，需要留意葉片顏色的細微變化、土壤濕度是否均勻，以及是否有蟲害的早期跡象。相比理想狀態，你目前在田間巡查時主動留意植物細節及辨別正常與異常狀態的觀察能力仍有差距，可能導致早期問題未能及時被發現。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的植物巡查升級為「有目的的觀察」，為每次巡查設定三個固定重點，例如葉片顏色、土壤濕度、蟲害跡象',
                '學習建立「正常基準」：選取幾株健康植物作參照，記下各生長階段的外觀特徵，每次巡查時作比較',
                '巡查時放慢速度，每隔幾株停下來蹲低仔細看，特別檢查葉背、根部周圍土壤及莖部與土壤接觸的位置',
                '養成「觀察即記錄」的習慣：每次巡查後用一兩句話記下植物狀態，例如「第三排第五株：葉尖開始變黃」',
                '與主管一起做一次「觀察示範巡查」，請主管帶你走一遍種植區，學習有經驗種植人員的觀察視角和方法',
                '記住對植物最有利的觀察，不是等到問題明顯才注意，而是在每次日常巡查中都保持細心和好奇心',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '在魚類護理工作中，觀察力是發現問題最早的工具，因為魚類無法用語言表達不適，所有健康狀況都只能通過行為和外觀的變化來傳遞，例如魚隻聚集水面可能是缺氧的訊號。相比理想狀態，你目前在日常巡查中主動留意魚隻細節及辨別正常與異常狀態的能力仍有差距，可能導致早期問題未能及時發現。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的魚缸巡查升級為「有目的的系統觀察」，為每次巡查設定五個固定觀察重點：游動深度、進食反應、外觀狀態、水體顏色和設備狀況',
                '為每個魚缸建立「正常狀態基準記錄」，記下魚隻健康時的典型游動深度、進食積極程度和水體顏色',
                '每次餵飼後，停留觀察兩至三分鐘，留意每條魚的進食反應，哪條魚今天進食量明顯少了',
                '養成「觀察即記錄」習慣：巡查後立即把觀察結果記在工作日誌中，包括任何與基準記錄不符的情況',
                '與主管進行一次「觀察示範巡查」，請主管帶你一起巡查所有魚缸，學習有經驗護理員的觀察視角和方法',
                '記住對魚隻而言，你的眼睛是牠們最重要的保護工具，因為牠們無法告訴你自己不舒服',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要「全農場」層面的觀察視角，在農場巡查時同時關注農作物生長狀態、設施設備運作狀況、蟲害活動跡象，以及不同崗位工作人員的工作進度和協作狀況。相比理想狀態，你目前在農場整體巡查中保持全面細心觀察及從整體識別潛在問題的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '為每次農場整體巡查建立「多維度巡查清單」，把巡查觀察重點分成五個維度：農作物狀態、設施設備狀態、蟲害跡象、工作進度，以及環境安全狀況',
                '在農場巡查中培養「整體先行、局部跟進」的觀察策略：先用全局視角快速瀏覽農場各區域整體狀況，再針對看起來異常的位置進行更仔細的局部觀察',
                '建立農場各區域的「正常狀態基準記錄」，記錄每個區域正常外觀、運作聲音和整體狀態，讓這份記錄成為日後巡查時判斷是否出現偏差的比較標準',
                '每次農場巡查後，立即用兩至三分鐘把觀察到的重要情況記錄下來，包括任何與基準狀態不符的情況、需要跟進的事項，以及已處理的問題',
                '把農場巡查視為主動尋找問題的過程，帶著「今天農場有什麼地方可以做得更好？有什麼潛在問題需要在它擴大之前發現？」的問題意識進行巡查',
              ],
            },
          ],
        },
        {
          // Critical thinking skills
          abilityName: '批判性思考能力',
          displayName: '批判性思考能力',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護除了基本操作外，還需要在多個可能原因中判斷最可能的問題來源，並在不同解決方案之間作出合理選擇，結合觀察、經驗及邏輯分析。相比理想狀態，你目前在分析情況、評估選項及作出合理判斷方面仍有提升空間，可能影響複雜情境下的決策品質與工作效率。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '遇到設備問題時，試試從不同角度思考，例如問自己「還有沒有其他可能造成這個問題的原因？」',
                '比較不同維修方案的優點和風險，慢慢培養自己評估和選擇最合適維護方法的能力',
                '試試用簡單邏輯框架幫助思考維護問題，例如先找出問題根源，再決定維修方法',
                '完成維修任務後，花幾分鐘反思自己的判斷是否正確，想想下次有什麼地方可以做得更好',
                '多和主管或同事討論遇到的設備問題，從不同人的經驗中學習不同的維護思考方式',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '批判性思考在種植工作中的體現，是在面對種植情況時多想一步，例如植物生長比預期慢時，同時考慮水質、光照、溫度等多個可能原因。相比理想狀態，你目前在多角度思考種植問題及評估不同可能性的能力仍有差距，可能影響你處理複雜種植問題時的判斷準確性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '發現植物問題時，在向主管匯報前，先試著自己列出至少兩個可能的原因，訓練從多角度思考的習慣',
                '學習用「排除法」分析植物問題：例如「如果是澆水過多，根部應有腐爛跡象，但根部正常，所以可能不在澆水」',
                '主管給出指示後，嘗試用自己的話複述：「你的意思是因為氣溫升高，所以需要增加澆水頻率，對嗎？」',
                '培養「比較觀察」習慣：找出同批種植中長得最好和最差的各一株，思考差異背後的可能原因',
                '在日常種植工作中養成問「為什麼」的習慣：例如「為什麼施肥要在早上而不是下午進行？」',
                '記住批判性思考的起點只是比別人多問一個「為什麼」，這個習慣會讓你從執行任務的種植員成長為真正理解種植工作的技術人員',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '批判性思考在魚類護理工作中的體現，是在面對魚缸情況時能夠超越表面現象，進一步問「為什麼？」例如水質pH值偏高時，同時思考是天氣、植物光合作用還是飼料份量引起的。相比理想狀態，你目前在從多個角度思考護理情況及評估不同可能性的能力仍有差距，可能影響處理複雜水質問題時的判斷準確性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '發現魚缸異常情況時，在採取行動前，先在腦海中或筆記本上列出至少兩個可能的原因，不要停留在第一個解釋',
                '學習把魚缸各項指標當作相互關聯的系統來看待，例如pH值偏高時，同時查看水溫、溶氧量和氨氮水平',
                '主管給出解釋後，嘗試用自己的話複述：「你的意思是因為水溫上升，溶氧量下降，所以魚隻才會浮頭，對嗎？」',
                '培養「比較不同魚缸」的批判性觀察習慣：某個魚缸出現問題時，對比其他條件相近的魚缸，思考為什麼只有這個出問題',
                '在日常護理工作中養成問「為什麼」的習慣：例如「為什麼餵飼要在早上而不是下午進行？」每次得到答案都加深理解',
                '記住批判性思考的起點只是多問一個「為什麼」，這個習慣會讓你從按程序操作的護理員，成長為真正理解魚類護理的專業人員',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '批判性思考在農場營運管理中尤為重要，因為這個崗位的決定影響農場整體。例如某批農作物產量低於預期時，需要同時考慮種植程序、蟲害防治時機、灌溉施肥安排及各崗位協作等多個因素。相比理想狀態，你目前在農場管理中從多個角度評估情況及把分析結果應用於改善運作的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '當農場出現運作問題或結果不理想時，在作出任何結論之前，要求自己列出至少三個可能的原因，而不是接受第一個看起來合理的解釋',
                '培養「假設質疑」思考習慣：當農場某個做法已成為慣例時，定期問自己「我們為什麼一直這樣做？有沒有更好的方法？這個做法現在是否仍然最適合？」',
                '向主管匯報農場問題或提出改善建議時，採用「問題、分析、建議」結構：清楚描述問題，分析最可能的原因，再提出一至兩個具體改善建議及預期效果',
                '在農場各崗位之間建立定期的「運作回顧交流」習慣，每週或每兩週與種植技術員、生態照護導師和系統維護員一起，回顧農場運作中出現的問題和改善',
                '在閱讀農場運作數據和記錄時，培養主動尋找異常模式的習慣，例如某個農場區域的蟲害記錄是否顯示出季節性規律，讓數據記錄成為批判性分析的材料',
              ],
            },
          ],
        },
        {
          // Attention to detail
          abilityName: '注重細節',
          displayName: '注重細節',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護中，水流速度的微小變化、管道接口的鬆動、設備的異常聲音及植物葉片的顏色變化，往往都是潛在問題的早期徵兆。相比理想狀態，你目前在觀察及處理細節方面的敏感度與穩定性仍有提升空間，可能影響對問題的早期識別能力及整體工作的可靠性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '建立系統化的維護檢查習慣，例如每天按固定清單逐一檢查水泵、管道和過濾設備的狀況',
                '每次只專注完成一項維護任務，避免同時處理太多事情，減少因分心而忽略重要細節',
                '在關鍵維修步驟中，故意放慢速度，給自己足夠時間仔細觀察和確認每個細節是否正確',
                '學習辨識設備「正常運作」和「出現異常」之間的細微差別，讓自己的判斷越來越準確',
                '使用維護記錄表追蹤每天的設備狀態變化，幫助自己及早發現潛在問題，建立長期觀察習慣',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植工作充滿需要細心對待的細節，例如播種時的埋放深度和間距、移植時根部的處理方式，以及施肥時的份量準確性。相比理想狀態，你目前在種植操作中主動留意細節及確保每個步驟按正確標準執行的能力仍有差距，可能逐漸影響整批農作物的種植質素。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '為每項種植操作建立「細節核查清單」，例如播種清單包括：種子方向是否正確、埋放深度是否一致、間距是否均勻',
                '開始任何種植操作前，先花30秒確認已準備好所需工具和材料，了解今次操作的標準要求是什麼',
                '操作過程中，每完成一個小步驟就短暫停頓確認，例如移植完一株幼苗後，檢查幼苗是否站立穩固',
                '發現操作結果出現不一致時，例如某幾株植物間距明顯比其他寬，立即停下來調整，不要繼續完成整排才修正',
                '每次完成一個種植區域的操作後，從稍遠的距離回望整個區域，從整體評估是否整齊一致',
                '記住在種植工作中，細心不是做事慢，而是做事準。每個細節做對了，最終節省的是重工和補救的時間',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類護理工作對細心程度的要求極高，因為錯誤的代價往往比種植工作更即時和嚴重。飼料份量過多會污染水質，水質數據記錄錯誤會影響主管的護理決定，而細小的外觀異常可能是疾病的早期警示。相比理想狀態，你目前在魚類護理操作中主動留意細節及確保每個步驟按正確標準執行的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '為每項魚類護理操作建立「細節核查清單」，例如餵飼清單包括：確認飼料品種正確、份量準確、每個魚缸都已餵飼、魚隻反應正常',
                '在每次巡查魚缸時，採用固定觀察順序：先看水面狀態、再看魚隻游動深度、再近距離觀察外觀、最後檢查魚缸壁和設備狀態',
                '記錄水質測量數值時，寫下後立即再看一遍確認記錄的數字與儀器顯示一致，防止記錄錯誤',
                '在工作後段，當身體疲勞可能影響細心程度時，主動放慢操作速度，用刻意放慢的速度補償疲勞帶來的注意力下降',
                '不允許自己的巡查停留在「整體感覺正常」的層面，要求自己每次都能說出具體觀察到的細節',
                '記住在魚類護理工作中，每一個被忽略的細節都可能產生超乎預期的後果，細心是保護魚隻最直接的方式',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要在多種不同類型工作中同時保持細心，包括收割時評估農作物品質、包裝時確保重量和封口準確、蟲害巡查時識別植物上的細微跡象，以及設施巡查時留意設備的異常聲音。相比理想狀態，你目前在跨越多種農場工作類型時保持全面細心的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '針對這個崗位涉及的每種主要工作類型，分別建立「細節核查清單」：收割清單包括成熟度判斷標準和品質篩選要點；包裝清單包括重量核查、封口檢查和標籤確認；蟲害巡查清單包括重點檢查部位和常見蟲害早期跡象',
                '執行任何需要細心的農場工作時，採用「先整體後局部」觀察模式：先從較遠的距離對工作區域作整體評估，再針對看起來需要仔細檢查的地方進行近距離細部觀察',
                '在收割和包裝工作中，建立「抽查確認」習慣：每完成一定數量的工序後，隨機抽取幾個樣本進行仔細品質檢查，而不是只在開始時仔細、後段因疲勞而降低細心程度',
                '發現某個需要細心處理的細節問題時，立即停下來處理，而不是繼續完成整個工序後再回頭，例如包裝時發現封口機出現細微封口不完整問題，立即停機調整',
                '在工作量大或工作節奏快的時段，特別提醒自己維持細心標準，必要時適當放慢操作速度，以確保細心程度不因趕時間而下降',
              ],
            },
          ],
        },
        {
          // Patience
          abilityName: '耐心',
          displayName: '耐心',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護通常需要長時間進行細緻且重複的操作，例如逐步檢查設備、慢慢調整水流系統及觀察動植物的細微變化，這些工作往往無法立即看到成果。相比理想狀態，你目前在面對需要長時間專注及重複操作的工作時，耐性與持續投入的能力仍有提升空間，可能影響工作完成的品質。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把需要長時間完成的維護任務分拆成幾個較小的步驟，逐步完成，減少感到壓力的情況',
                '為自己設定短期可達成的小目標，每完成一個就給自己一個肯定，提升過程中的動力',
                '建立固定的維護工作節奏，在適當時候安排短暫休息，幫助自己保持專注和穩定狀態',
                '提醒自己細緻的維護工作本來就需要時間，不要因為想快點完成而跳過重要的檢查步驟',
                '透過重複練習慢慢培養耐性，例如反覆練習調較水質參數，每次都讓自己更熟練穩定',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植技術員的許多核心操作需要耐性，例如逐粒播種、小心移植幼苗，以及在等待種子發芽期間耐心維持每天的護理工作。相比理想狀態，你目前在執行需要長時間重複且不見即時成果的種植工作時，維持耐性的能力仍有差距，可能影響操作的細心程度及護理穩定性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '執行需要長時間重複的種植任務時，把整個任務分解成小段落，例如播種一整盤分成「每完成十格為一段」',
                '為自己建立舒適的工作節奏：不要因為想快點完成而加快手部動作，找到既舒適又準確的節奏並保持',
                '執行重複性操作時，把注意力放在每個動作的質素上，例如移植幼苗時專注於每株根部是否放置妥當',
                '感到不耐煩或想加快速度時，提醒自己：現在的操作質素直接決定這批植物之後的生長狀況',
                '耐性已到極限時，告知主管並請求短暫休息，讓自己重新調整狀態再繼續，不要在疲憊狀態下強行完成',
                '記住在農業種植中，耐性不只是性格特質，它是一種實際的工作技能，每株被細心對待的植物都是你的成果',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類護理工作需要耐性的方式很多：餵飼後需要耐心觀察每條魚的進食反應、等待水質儀器顯示穩定數值、靜靜觀察疑似生病的魚隻行為，以及耐心等待護理調整後的成效出現。相比理想狀態，你目前在魚類護理各個需要耐性的環節維持足夠耐心的能力仍有差距，可能影響護理操作的質素及評估的準確性。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每次餵飼後，設定固定的「觀察等待時間」，例如投入飼料後至少停留觀察三分鐘，把這段時間視為護理工作的一部分',
                '使用水質測量儀器時，記住不同儀器有不同的穩定時間，在等待期間可以記錄其他觀察結果，讓等待時間得到善用',
                '需要用網捕撈特定魚隻時，提醒自己「慢比快更有效」，先等候魚隻游到容易捕撈的位置，再緩慢穩定地移動網',
                '魚隻接受護理調整後，與主管商定合理的觀察期（例如三至五天），在此期間堅持執行調整後的護理計劃並記錄觀察',
                '感到不耐煩或想加快操作速度時，提醒自己：魚類對環境和護理的反應往往需要時間才能顯現，倉促判斷代價很大',
                '記住對魚隻而言，你的耐心是牠們接受最高質素護理的保障，每次願意多等一分鐘都可能是發現重要問題的關鍵時刻',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '營運與收成管理員需要耐性的情境比其他崗位更多樣，包括逐株評估收割品質、確保蟲害防治噴灑覆蓋每個植株位置、持續跟進反覆出現的設施問題，以及等待其他崗位完成工作才能推進自己的任務。相比理想狀態，你目前在農場運作管理各個需要耐性的環節中維持足夠耐心的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在收割工作中，把品質評估從「完成收割量」的目標分離出來，建立「先確保品質、數量是結果」的工作心態，每株農作物的品質評估需要多少時間就花多少時間',
                '進行蟲害防治噴灑時，採用系統性噴灑路徑，確保不遺漏任何角落，例如先噴植物上表面、再噴下表面、再噴莖部，讓固定噴灑順序代替「感覺差不多了」的主觀判斷',
                '農場設施問題需要多次跟進才能解決時，建立「問題追蹤記錄」，記錄問題首次發現日期和每次跟進的處理內容，讓耐心的持續跟進轉化為可見的工作進展',
                '與其他崗位協調工作時，把等待其他崗位的時間轉化為處理其他工作事項的時間，例如等待種植技術員完成修剪才能收割時，利用這段時間進行農場設施巡查',
                '在農場收成高峰期，品質要求和速度要求出現矛盾時，優先保證品質，因為品質問題的後續代價往往遠高於速度上的損失',
              ],
            },
          ],
        },
        {
          // Accuracy
          abilityName: '準確度',
          displayName: '準確度',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護對準確性有明確要求，例如正確測量水質數據、準確調整設備參數及依照標準流程操作，確保每個步驟都按要求完成。任何細微錯誤，如數值偏差或操作順序錯誤，都可能影響整體系統。相比理想狀態，你目前在執行任務時的準確度及穩定性仍有提升空間，可能增加錯誤發生的風險。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在執行關鍵維護操作時，刻意放慢節奏，例如調較水質參數時，確保每個數值都正確',
                '使用標準維護操作流程作為指引，按照步驟逐一執行，避免因遺漏步驟而出現錯誤',
                '建立「完成後檢查」的習慣，每次完成維修後，確認結果是否符合農場系統的標準要求',
                '使用記錄表格輔助工作，例如記錄每次水質測量的數值，幫助自己提升操作的準確性',
                '透過重複練習提升熟練程度，例如反覆練習安裝管道接頭，每次練習都讓操作更準確穩定',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植工作對準確性有直接要求，施肥份量必須按配方準確量取、播種深度需要一致、移植時幼苗間距需要均勻。相比理想狀態，你目前在執行種植操作時達到所需準確度的能力仍有差距，可能導致種植結果出現不一致，影響農場的整體產量和農作物品質標準。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '量取肥料份量或測量植株間距前，確認使用正確量具（例如量杯、量匙或間距尺），不要用目測代替量度',
                '為每項需要準確度的操作建立「標準參考」：例如用短木條標記正確的播種間距，每次播種時對照確保一致',
                '每完成一個小段落的操作後，抽查自己的準確性，例如完成十個播種格後，用量具確認深度和間距是否符合標準',
                '使用需要調配的液體肥料或農藥時，嚴格按照主管給出的配方進行，有疑問在配製前先確認清楚',
                '建立「雙重確認」習慣：執行重要操作前，把準備好的份量或設定再看一遍，確認無誤後才開始',
                '記住在種植工作中，準確性是可以通過練習和使用正確工具提升的技能，每次有意識地核對都是在訓練自己',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類護理對準確性有嚴格要求：飼料份量需根據魚缸生物負載量精確計算，水質調節劑必須按指定濃度配製，水質數據記錄必須準確，隔離病魚時需準確識別需要隔離的個體。相比理想狀態，你目前在執行各項魚類護理操作時達到所需準確度的能力仍有差距，可能對水質穩定性和魚隻健康帶來直接影響。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '量取飼料份量時，永遠使用正確量具（例如精確電子秤或標準量匙），不要用目測估計，避免累積偏差影響水質和魚隻健康',
                '配製水質調節化學品時，嚴格按照主管提供的配方和份量，配製完成後把配方和實際份量記錄在工作日誌中',
                '記錄水質測量數值時，養成「測量、記錄、核對」三步習慣：記錄後再看一遍儀器確認數值一致，確認日期和魚缸編號正確',
                '觀察和記錄魚隻狀況時，使用具體描述：例如「2號魚缸一條魚的左側魚鰭有約三毫米長的破損，位置在魚鰭上方三分之一處」',
                '建立「雙重確認」操作習慣：執行任何對魚隻健康有直接影響的操作前，確認份量或設定正確後才開始',
                '記住在魚類護理工作中，準確性是每一條魚能夠在正確環境中健康生存的基本保障',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '準確性對農場營運與收成管理員的重要性體現在多個工作環節，包括包裝重量需準確符合標示、農藥濃度需嚴格按照配方、農場運作數據需準確記錄，以及收割時機的判斷需要準確識別農作物已達到最佳收割狀態。相比理想狀態，你目前在多個不同工作環節中維持所需準確度的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '在包裝工序中建立嚴格的重量核查程序：每份農產品包裝完成後，在封口前進行一次重量確認，確認重量符合標示要求後才封口，並定期對包裝秤進行校準確認',
                '配製蟲害防治農藥時，採用「量取、記錄、核對」三步程序：按配方量取份量、把實際量取的份量記錄在農藥使用記錄表上、在混合前再次核對記錄份量與配方是否一致',
                '建立農場運作數據的「即時記錄」原則：所有需要記錄的數據，例如每天收割量、包裝數量和農藥使用量，在操作完成後立即記錄，而不是事後憑記憶補記',
                '為農作物收割時機的判斷建立具體的多維度評估標準，例如番茄的收割標準包括顏色達到特定深度、按壓有適當軟硬度、果梗輕易脫落，讓判斷基於多個可觀察指標',
                '在進行農場運作記錄時，養成「記錄後核對」習慣：把數據記錄在表格後，重新閱讀一遍確認記錄內容與實際情況一致，特別注意數字單位是否正確',
              ],
            },
          ],
        },
        {
          // Discipline
          abilityName: '紀律性',
          displayName: '紀律性',
          feedbackByJobRole: [
            { // Farm Systems Maintenance Officer
              /** label is 差異 */
              differenceText: '農場系統維護需要高度自律，包括按時完成巡查、持續進行日常保養、準確記錄操作數據，以及長期保持一致的工作標準。這些工作往往缺乏即時回饋，但對系統穩定性具有長遠影響。相比理想狀態，你目前在維持穩定工作節奏、持續執行任務及自我管理方面仍有提升空間，可能影響工作的一致性與整體表現。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '建立固定的每日維護時間表，例如列明每天巡查設備和測量水質的時間，讓工作節奏清晰',
                '使用維護清單管理每天的工作內容，完成一項就打剔，清楚看到自己的工作完成進度',
                '為自己設定清楚的維護目標，並定期檢視完成情況，了解自己是否按計劃推進維護工作',
                '培養按時完成維護工作的習慣，如果發現自己有拖延傾向，立即告訴主管，一起找解決方法',
                '從簡單的日常設備巡查開始建立自律習慣，習慣了之後再慢慢提高對自己的維護工作要求',
              ],
            },
            { // Planting Technician
              /** label is 差異 */
              differenceText: '種植工作有嚴格的時間性，澆水若推遲數小時在炎熱天氣下可能已對植物造成傷害，施肥若不按計劃執行可能打亂生長周期。相比理想狀態，你目前在沒有即時監督的情況下自主維持工作規律及按時完成種植任務的能力仍有差距，可能影響農作物的整體健康狀況。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '每天開始工作前，用五分鐘確認當天所有種植任務和對應時間要求，把清單貼在顯眼位置作為全天指引',
                '為每日固定種植任務設定具體完成時間目標，例如「澆水必須在早上9時前完成，施肥在11時前完成」',
                '想要跳過某個步驟時，先問自己：「如果我現在不做這一步，會對植物造成什麼影響？」讓責任感推動自律',
                '在工作日中設定兩至三個固定的「自我檢查時間點」，確認任務進度是否符合預期，有延誤就及時調整節奏',
                '告知主管你希望建立的工作習慣，請主管在最初幾週定期給你簡短反饋，讓你了解自律程度是否達到農場要求',
                '記住自律是可以通過日積月累訓練建立的能力，每天按計劃完成種植任務，就是在建立農場對你的信任基礎',
              ],
            },
            { // Care Trainer
              /** label is 差異 */
              differenceText: '魚類護理工作對自律性的要求極高，因為魚類的生存對護理工作的時間性和一致性有不可妥協的依賴。與種植工作不同，魚類護理中某些環節的疏忽，例如忘記開啟曝氣設備，可能在幾十分鐘內就對魚隻造成嚴重影響。相比理想狀態，你目前在自主維持魚類護理工作時間性和標準方面仍有差距，可能對魚缸生態系統帶來即時風險。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '把每天的魚類護理任務整理成帶有具體執行時間的「每日護理時間表」，例如「早上9:00第一次餵飼、9:30水質測量和記錄」',
                '使用手機鬧鐘為每項有時間要求的護理任務設定提醒，讓外部提醒在初期幫助自己建立固定的工作節律',
                '每天開始工作時，花五分鐘確認所有護理任務和對應時間要求，完成一項立即在時間表上打剔',
                '工作日中設定兩個固定的「自我進度確認時間」，例如上午和下午的中間點，確認任務進度是否符合預期',
                '告知主管你希望建立的護理工作習慣，請主管在最初幾週定期給你簡短反饋，了解自律程度是否符合要求',
                '記住對農場中每一條魚而言，你今天的自律和明天的自律同樣重要，每天按時完成所有護理任務是最基本的責任',
              ],
            },
            { // Operations & Harvest Manager
              /** label is 差異 */
              differenceText: '農場營運與收成管理員的工作範疇最廣、獨立工作比例最高，需要在沒有即時監督的情況下，自律地按照農場標準執行收割、包裝、蟲害防治和巡查等工作，並在工作量大、壓力高時仍維持每個環節的質素標準。相比理想狀態，你目前在廣泛農場管理工作中自主維持工作標準和持續跟進任務的能力仍有差距。',
              /** label is 建議改善方式 */
              suggestedImprovements: [
                '建立個人「農場管理自律系統」，包括三個核心工具：每天開始工作時制定「當日優先任務清單」、工作進行中使用「任務進度追蹤表」、工作結束時完成「每日工作總結」',
                '在每天的工作安排中，把最需要準確性和細心程度的工作（例如農藥配製、包裝品質核查）安排在個人注意力和體力最充沛的時段，讓工作安排配合個人的狀態規律',
                '針對農場運作記錄建立「不過夜原則」：所有當天需要記錄的農場運作數據，必須在當天工作結束前完成記錄，不允許延遲到第二天補記',
                '工作量突然增加或同時出現多個緊急任務時，立即與主管溝通，說明目前工作狀況和需要作出的優先次序選擇，讓優先次序的管理在與主管的溝通基礎上進行',
                '每週結束時，花十至十五分鐘回顧本週的農場運作管理情況：哪些工作按計劃完成、哪些工作出現延誤、原因是什麼、下週如何改進',
              ],
            },
          ],
        },
      ],

      // *** player data variables ***
      genderIcon: '',
      birthYear: '',
      location: '',
      industry: '',
      workYears: 0,
      abilityScores: [],
      categoryScores: [],
      attitudeScores: [],
      bestFitArchetypeIndex: 0,
      wheelCapabilityData: [],
      score: 0,
      bestFitRoleIndex: 0,
      bestFitScore: 0,
      desiredRoleIndex: 0,
      /**
       * Populated with 3 furthest off `abilityScores` from desired role ability scores,
       * with corresponding abilityImprovementInformation entries.
       */
      leastFitAbilities: [],
      lowestAbilities: [],
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeClass',
      'characters',
      'tooltip',
      'narrative',
      'lastNarrative',
      'nextNarrative',
      'narrativeNavbarText',
      'narrativeText',
      'group',
      'me',
      'metrics',
      'playerResponsesByReferenceId',
      'game',
      'dateActiveGameCompleted',
      'challenge'
    ]),
    username() {
      const preferredName = this.playerResponsesByReferenceId.get('Preferred Name');
      if (preferredName) return preferredName;

      const {
        firstName = '',
        lastName = '',
        email = ''
      } = this.me || {};
      return firstName || lastName ? `${firstName} ${lastName}` : email;
    },
    date() {
      return (this.game.carryOverMetricsFromActive && this.dateActiveGameCompleted != null)
        ? new Date(this.dateActiveGameCompleted).toLocaleDateString('en-HK', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : ((this.challenge && this.challenge.completed)
          ? new Date(this.challenge.completed).toLocaleDateString('en-HK', { year: 'numeric', month: '2-digit', day: '2-digit' })
          : ((this.group && this.group.updated)
            ? new Date(this.group.updated).toLocaleDateString('en-HK', { year: 'numeric', month: '2-digit', day: '2-digit' })
            : new Date(Date.now()).toLocaleDateString('en-HK', { year: 'numeric', month: '2-digit', day: '2-digit' })));
    },
    reportFileName() {
      return (this.activeClass != null && this.activeClass.studentReportFileName != null)
        ? this.activeClass.studentReportFileName
        : (this.activeEnvironment.reportTitle || this.game.reportTitle || 'Report');
    },
    logo() {
      return this.activeEnvironment.reportLogo || this.activeEnvironment.creditsLogo || this.activeEnvironment.titleLogo;
    },
    abilityBlurb() {
      switch (this.bestFitRoleIndex) {
        case 0: // farm system
          if (this.bestFitScore <= 10) {
            return '每個人都有不同的學習節奏，而你願意參與這個體驗，本身已經是一個很重要的開始。從目前的結果來看，你與「農場系統維護員」這個角色的契合度仍然較低。這個工作通常需要穩定的專注力、對細節的敏感度，以及在面對系統問題時保持冷靜並作出判斷的能力。\n\n這並不代表你不適合工作，而是這類以設備運作與問題解決為主的工作模式，暫時未必與你的自然傾向相符。建議你可以多探索其他類型的工作體驗，發掘更能讓你感到投入與自在的方向。找到適合自己的環境，才是最重要的一步。';
          } else if (this.bestFitScore <= 20) {
            return '從目前的結果來看，你與「農場系統維護員」這個角色仍有一定距離。這類工作需要一定程度的邏輯思考能力、對系統運作的理解，以及在面對突發情況時保持冷靜。\n\n你可能已經展現出一些相關能力，但整體而言仍未完全符合這個角色的要求。這是很正常的情況，因為每個人的優勢與興趣都不同。你可以考慮多嘗試不同類型的任務，慢慢找到最適合自己的方向。';
          } else if (this.bestFitScore <= 40) {
            return '你的表現顯示，你與「農場系統維護員」這個角色開始出現一些基礎的連結。你可能已具備部分相關能力，例如基本的理解力或在某些情況下能作出判斷，但整體穩定性仍有提升空間。\n\n這個角色特別重視持續專注、細節觀察以及問題解決能力。如果你對這類工作有興趣，可以透過更多練習與體驗，逐步提升相關能力，未來仍有發展的可能性。';
          } else if (this.bestFitScore <= 60) {
            return '你的結果顯示，你與「農場系統維護員」這個角色已有一定程度的契合。你在部分關鍵能力上已有不錯的表現，例如理解系統運作或在面對問題時作出基本判斷。\n\n不過，這個角色仍需要較高的穩定性與精準度，特別是在細節處理及持續專注方面。如果你有興趣朝這個方向發展，可以進一步加強這些能力，將有助於提升整體表現。';
          } else if (this.bestFitScore <= 80) {
            return '你的表現顯示，你與「農場系統維護員」這個角色有良好的契合度。你已具備多項重要能力，包括問題分析、系統理解，以及在壓力下保持冷靜的表現。\n\n這代表你在這類以系統運作與維護為主的工作中，具備不錯的潛力。若能進一步提升細節處理的精準度與主動預防問題的能力，你將更有機會在這個角色中表現出色。';
          }
          return '你的結果顯示，你與「農場系統維護員」這個角色具有高度契合。你在關鍵能力上表現出色，包括邏輯思考、細節觀察，以及在面對問題時保持冷靜並作出有效判斷。\n\n這代表你非常適合從事這類以系統管理與問題解決為核心的工作。你不僅能應對日常運作，亦具備進一步提升與優化系統的潛力。這是一個值得你深入發展的方向。';
        case 1: // planting technician
          if (this.bestFitScore <= 10) {
            return '每個人都有不同的節奏，而你願意參與這個體驗已經是一個很好的開始。從目前結果來看，你與「種植技術員」這個角色的契合度仍然較低。這個角色通常需要耐心、穩定的專注力，以及對細節的持續關注，例如種植步驟、時間控制及重複性工作。\n\n這並不代表你不適合工作，而是這種以重複性操作及細節為主的工作模式，暫時未必最符合你的特質。建議你可以多嘗試不同類型的體驗，發掘更適合自己的方向。';
          } else if (this.bestFitScore <= 20) {
            return '你的結果顯示，你與「種植技術員」這個角色仍有一定距離。這類工作需要穩定的節奏、對細節的持續關注，以及對重複性任務的耐心。\n\n你可能已經展現出部分相關能力，但整體而言仍未完全符合這個角色的要求。這是很正常的，因為每個人對工作節奏與方式的適應程度不同。';
          } else if (this.bestFitScore <= 40) {
            return '你的表現顯示，你開始具備一些與「種植技術員」相關的基礎能力，例如在部分情況下能保持專注或完成指定步驟。不過，在穩定性及細節準確度方面仍有進步空間。\n\n如果你對這類工作有興趣，可以透過更多練習，逐步提升專注力與一致性，未來仍有發展機會。';
          } else if (this.bestFitScore <= 60) {
            return '你的結果顯示，你與「種植技術員」這個角色已有一定程度的契合。你在部分關鍵能力上已有良好表現，例如專注力及基本操作能力。\n\n不過，這個角色仍需要較高的穩定性與對細節的敏感度。如果能進一步提升工作的一致性與準確度，將更有助於你在這個角色中表現更佳。';
          } else if (this.bestFitScore <= 80) {
            return '你的表現顯示，你與「種植技術員」這個角色有良好的契合度。你能穩定完成重複性任務，並對細節有不錯的掌握。\n\n這代表你在這類需要耐心與一致性的工作中具備良好潛力。若能進一步提升效率與細節精準度，你將更具競爭力。';
          }
          return '你的結果顯示，你與「種植技術員」這個角色具有高度契合。你在專注力、細節處理及工作穩定性方面表現出色。\n\n這代表你非常適合從事這類需要高度一致性與耐心的工作。你具備在長時間重複性任務中維持品質的能力，是這個角色的重要優勢。';
        case 2: // care
          if (this.bestFitScore <= 10) {
            return '每個人都有不同的學習方式與節奏，而你願意參與這個體驗，本身已經是一個很重要的開始。從目前的結果來看，你與「生態照護導師」這個角色的契合度仍然較低。這個角色通常需要對動植物具備耐心與關懷，同時需要細緻的觀察能力，以及在面對生態變化時保持冷靜並作出適當判斷。\n\n這並不代表你不適合工作，而是這類以照顧生命、長時間觀察及細微變化為主的工作模式，暫時未必與你的自然傾向相符。建議你可以多探索不同類型的體驗，找出更能讓你感到投入與自在的方向。找到適合自己的節奏與環境，才是最重要的一步。';
          } else if (this.bestFitScore <= 20) {
            return '你的結果顯示，你與「生態照護導師」這個角色仍有一定距離。這類工作需要耐心、細心，以及對動植物狀態變化的持續關注，同時亦需要一定的責任感與穩定性。\n\n你可能已經展現出一些相關能力，例如在某些情況下能保持觀察或基本理解，但整體而言仍未完全符合這個角色的要求。這是很正常的情況，因為每個人對於照顧性與觀察性工作的適應程度不同。你可以透過更多不同的體驗，慢慢找到最適合自己的方向。';
          } else if (this.bestFitScore <= 40) {
            return '你的表現顯示，你開始與「生態照護導師」這個角色建立一些基礎連結。你可能已具備部分相關能力，例如在特定情況下能細心觀察，或對動植物狀態有基本理解，但整體穩定性與持續性仍有提升空間。\n\n這個角色特別重視耐心、同理心，以及對細微變化的敏感度。如果你對這類工作有興趣，可以透過更多實踐與學習，逐步提升觀察能力與照顧技巧，未來仍有發展的可能性。';
          } else if (this.bestFitScore <= 60) {
            return '你的結果顯示，你與「生態照護導師」這個角色已有一定程度的契合。你在部分關鍵能力上已有良好表現，例如觀察能力、基本照護技巧，以及在穩定環境中維持專注。\n\n不過，這個角色仍需要更高的穩定性與對細節變化的持續敏感度。如果你希望朝這個方向發展，可以進一步加強耐心及持續觀察能力，將有助於提升整體表現。';
          } else if (this.bestFitScore <= 80) {
            return '你的表現顯示，你與「生態照護導師」這個角色有良好的契合度。你已具備多項重要能力，包括細緻觀察、耐心照顧，以及在面對變化時保持穩定的表現。\n\n這代表你在這類以照顧與觀察為主的工作中具備良好潛力。若能進一步提升判斷能力及主動關注細節變化的能力，你將更有機會在這個角色中表現出色。';
          }
          return '你的結果顯示，你與「生態照護導師」這個角色具有高度契合。你在關鍵能力上表現出色，包括同理心、細緻觀察能力，以及在面對變化時保持冷靜並作出適當判斷。\n\n這代表你非常適合從事這類以照顧生命與維持生態平衡為核心的工作。你不僅能細心照顧動植物，亦具備引導他人理解及參與生態工作的潛力，是一個值得深入發展的方向。';
        case 3: // operations
          if (this.bestFitScore <= 10) {
            return '每個人都有不同的節奏與工作方式，而你願意參與這個體驗已經是一個很好的開始。從目前結果來看，你與「營運及收成管理員」這個角色的契合度仍然較低。這個角色通常需要良好的組織能力、工作規劃能力，以及在多項任務之間作出判斷與協調的能力。\n\n這並不代表你不適合工作，而是這類需要同時處理多個流程、節奏較快且需要持續決策的工作模式，暫時未必與你的自然傾向相符。你可以透過其他體驗，慢慢探索更適合自己的方向。';
          } else if (this.bestFitScore <= 20) {
            return '你的結果顯示，你與「營運及收成管理員」這個角色仍有一定距離。這類工作需要良好的時間管理能力、任務協調能力，以及在變化中作出判斷的能力。\n\n你可能已展現出部分相關能力，但整體而言仍未完全符合這個角色的要求。這是很正常的，因為這類角色通常需要較多經驗累積與實務練習。';
          } else if (this.bestFitScore <= 40) {
            return '你的表現顯示，你開始具備與「營運及收成管理員」相關的一些基礎能力，例如在部分情況下能進行簡單安排或理解流程，但整體統籌能力仍有提升空間。\n\n這個角色特別重視組織能力與應變能力。如果你對這類工作有興趣，可以透過更多練習，逐步提升規劃與協調能力。';
          } else if (this.bestFitScore <= 60) {
            return '你的結果顯示，你與「營運及收成管理員」這個角色已有一定程度的契合。你在部分關鍵能力上已有良好表現，例如基本組織能力及任務處理能力。\n\n不過，這個角色仍需要更高的整體協調能力與判斷能力。如果能進一步提升規劃及應變能力，你將更有機會勝任這個角色。';
          } else if (this.bestFitScore <= 80) {
            return '你的表現顯示，你與「營運及收成管理員」這個角色有良好的契合度。你已具備組織、協調及基本決策能力，能有效處理不同工作流程。\n\n若能進一步提升預判能力及在變化中的應對策略，你將更有機會在這個角色中表現出色。';
          }
          return '你的結果顯示，你與「營運及收成管理員」這個角色具有高度契合。你在組織能力、判斷能力及應變能力方面表現出色，能有效協調不同任務與流程。\n\n這代表你非常適合從事這類以管理與統籌為核心的工作。你不僅能處理日常運作，亦具備優化流程與提升效率的潛力，是一個值得深入發展的方向。';
        default:
          return '';
      }
    },
    bestFitRole() {
      return this.roles[this.bestFitRoleIndex] || null;
    },
    bestFitArchetype() {
      return this.archetypes[this.bestFitArchetypeIndex] || null;
    },
    desiredRole() {
      return this.roles[this.desiredRoleIndex] || null;
    },
    employed() {
      const employedReferenceValue = this.playerResponsesByReferenceId.get('Employed');
      if (employedReferenceValue == null) return this.industry !== 'Unemployed' ? 'Unknown' : '現時沒有工作';
      if (employedReferenceValue === '有') return '在職';
      if (employedReferenceValue === '沒有') return '現時沒有工作';
      return employedReferenceValue;
    },
    jobTitle() {
      const jobTitleReferenceValue = this.playerResponsesByReferenceId.get('Job Position');
      if (jobTitleReferenceValue == null) return 'None';
      return jobTitleReferenceValue;
    },
    senReferenceValue() {
      const senReferenceValue = this.playerResponsesByReferenceId.get('SEN');
      if (senReferenceValue == null) return 'No SEN info found for this player.';
      return senReferenceValue.replace(/<\/?[^>]+(>|$)/g, '');
    },
    sortedRoles() {
      if (this.roles.length < 4) return this.roles;

      const sortOrder = ([
        {
          index: 0,
          interest: (this.group && this.group.metrics.length > 37) ? this.group.metrics[37].value : 0,
        }, {
          index: 1,
          interest: (this.group && this.group.metrics.length > 38) ? this.group.metrics[38].value : 0,
        }, {
          index: 2,
          interest: (this.group && this.group.metrics.length > 39) ? this.group.metrics[39].value : 0,
        }, {
          index: 3,
          interest: (this.group && this.group.metrics.length > 40) ? this.group.metrics[40].value : 0,
        }
      ]).sort((a, b) => a.interest - b.interest);

      return sortOrder.map(r => this.roles[r.index]);
    },
    bestFitRoleCategoryScores() {
      if (!this.bestFitRole) return [];
      return this.categoryScores.map((categoryScore, index) => {
        const mappedScore = Object.assign({}, categoryScore);
        mappedScore.value = this.bestFitRole.categoryScores[index];
        return mappedScore;
      });
    }
  },
  methods: {
    ...mapActions([
      'getMyGroup',
      'stopSounds',
      'flashDanger'
    ]),
    async show() {
      this.showNarrator = true;
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.showNarratorNotification = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      await Vue.nextTick();
    },
    async reset() {
      await Vue.nextTick();
      await this.show();
    },
    navigate() {
      this.$refs.bottomBar.navigate();
    },
    async onComplete() {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      this.$emit('input');
    },
    async loadPageData() {
      try {
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    },
    setStats() {
      console.log(this.group);
      if (this.group && this.group.metrics && this.group.metrics.length >= 41) {
        // *** read demographic info ***

        const genderValue = this.group.metrics[0].value;
        this.genderIcon =
          (genderValue === 1)
            ? 'm'
            : ((genderValue === 2)
              ? 'f'
              : '');

        this.birthYear = this.group.metrics[1].value;

        const locationValue = this.group.metrics[2].value;
        switch (locationValue) {
          case 4: this.location = '離島'; break;
          case 3: this.location = '新界'; break;
          case 2: this.location = '九龍'; break;
          default: this.location = '香港'; break;
        }

        const industryValue = this.group.metrics[3].value;
        switch (industryValue) {
          case 1: this.industry = '行政及辦公室工作'; break;
          case 2: this.industry = '照顧動物'; break;
          case 3: this.industry = '創意藝術及設計'; break;
          case 4: this.industry = '活動管理'; break;
          case 5: this.industry = '農場與耕種'; break;
          case 6: this.industry = '餐飲業'; break;
          case 7: this.industry = '醫療與支援服務'; break;
          case 8: this.industry = '圖書館'; break;
          case 9: this.industry = '運輸與物流'; break;
          case 10: this.industry = '酒店業'; break;
          case 11: this.industry = '製造業'; break;
          case 12: this.industry = '零售與倉儲'; break;
          case 13: this.industry = 'STEM（科學、技術、工程、數學）'; break;
          case 15: this.industry = '失業'; break;
          default: this.industry = '其他'; break;
        }

        this.workYears = this.group.metrics[4].value;


        // *** read scores ***

        // compute desiredRoleIndex and targetAbilityScores based on desired role value
        // NOTE: best fit just uses player-specified desired role as the target
        const desiredRoleValue = this.group.metrics[41].value;
        this.desiredRoleIndex = desiredRoleValue - 1;
        const valid = (this.desiredRoleIndex >= 0) && (this.desiredRoleIndex < this.roles.length);
        if (!valid) this.desiredRoleIndex = 0; // just fallback to first role
        const r = this.roles[this.desiredRoleIndex];
        const targetAbilityScores = (r && r.abilityScores) ? r.abilityScores : [];
        const targetAbilityWeights = (r && r.abilityWeights) ? r.abilityWeights : [];
        const targetAbilityWeightsNormalized = targetAbilityWeights.map(w => w * 4);

        const normalizedWheelScores = [];
        const { abilityScores, categoryScores, attitudeScores } = this;
        abilityScores.length = 0; // clear
        categoryScores.length = 0; // clear
        attitudeScores.length = 0; // clear

        const normalizedMetric = (metric) => {
          if (metric.max == null || metric.min == null) return metric.value;
          return (metric.value - metric.min) / Math.max(1, metric.max - metric.min);
        };

        const averagedMetric = (metrics, weights) => {
          if (!metrics || !(metrics.length) || (weights && weights.length < metrics.length)) return 0;
          let sum = 0;
          metrics.forEach((metric, index) => {
            sum += metric.value * (weights ? weights[index] : 1);
          });
          return sum / metrics.length;
        };

        const readAbilityScores = (metrics, names, categoryName, weights) => {
          names.forEach((abilityName, index) => {
            abilityScores.push({ name: abilityName, value: metrics[index].value });
            normalizedWheelScores.push({ name: abilityName, value: normalizedMetric(metrics[index]) });
          });
          categoryScores.push({ name: categoryName, value: averagedMetric(metrics, weights) });
        };

        readAbilityScores(
          this.group.metrics.slice(5, 9),
          [
            // Enjoys outdoor work
            '喜歡戶外工作',
            // Likes routine tasks
            '喜愛例行性工作',
            // Adapts to changes
            '能適應變化',
            // Tidiness
            '注重整潔',
          ],
          this.abilityCategories[0].name,
          targetAbilityWeightsNormalized.slice(0, 4),
        );

        readAbilityScores(
          this.group.metrics.slice(9, 13),
          [
            // Teamwork
            '團隊合作',
            // Solo work
            '獨立工作',
            // Decision making
            '決策能力',
            // Communication skills
            '溝通能力',
          ],
          this.abilityCategories[1].name,
          targetAbilityWeightsNormalized.slice(4, 8),
        );

        readAbilityScores(
          this.group.metrics.slice(13, 17),
          [
            // Strong physical skills
            '體能強健',
            // Enjoys hands-on work
            '喜愛實地操作工作',
            // Environment endurance
            '環境耐受能力',
            // Body coordination
            '身體協調能力',
          ],
          this.abilityCategories[2].name,
          targetAbilityWeightsNormalized.slice(8, 12),
        );

        readAbilityScores(
          this.group.metrics.slice(17, 21),
          [
            // Loves plants and fish
            '喜愛植物與魚類',
            // Understand life cycle
            '了解生命週期',
            // Persistence & resilience
            '具備耐性',
            // Passionate
            '充滿熱誠',
          ],
          this.abilityCategories[3].name,
          targetAbilityWeightsNormalized.slice(12, 16),
        );

        readAbilityScores(
          this.group.metrics.slice(21, 25),
          [
            // Problem solving
            '解難能力',
            // Learning ability
            '學習能力',
            // Observant
            '觀察力',
            // Critical thinking skills
            '批判性思考能力',
          ],
          this.abilityCategories[4].name,
          targetAbilityWeightsNormalized.slice(16, 20),
        );

        readAbilityScores(
          this.group.metrics.slice(25, 29),
          [
            // Attention to detail
            '注重細節',
            // Patience
            '耐心',
            // Accuracy
            '準確度',
            // Discipline
            '紀律性',
          ],
          this.abilityCategories[5].name,
          targetAbilityWeightsNormalized.slice(20, 24),
        );

        // Calm
        attitudeScores.push({ name: '冷靜', value: this.group.metrics[29].value });
        // Empathy
        attitudeScores.push({ name: '同理心', value: this.group.metrics[30].value });
        // Diligence
        attitudeScores.push({ name: '勤奮', value: this.group.metrics[31].value });
        // Willing to learn
        attitudeScores.push({ name: '樂於學習', value: this.group.metrics[32].value });
        // Punctuality
        attitudeScores.push({ name: '守時', value: this.group.metrics[33].value });
        // Responsibility
        attitudeScores.push({ name: '責任感', value: this.group.metrics[34].value });
        // Flexibility
        attitudeScores.push({ name: '靈活性', value: this.group.metrics[35].value });
        // Proactiveness
        attitudeScores.push({ name: '主動性', value: this.group.metrics[36].value });

        // populate wheelCapabilityData
        this.wheelCapabilityData.length = 0; // clear
        this.abilityCategories.forEach((category, index) => {
          this.wheelCapabilityData.push({
            name: category.name,
            color: category.color,
            isTop: false,
            subcapabilities: normalizedWheelScores.slice(index * 4, (index + 1) * 4),
          });
        });

        this.score = averagedMetric(abilityScores);

        // leastFitAbilities
        this.leastFitAbilities = [{}, {}, {}];
        const leastFitAbilityDifferences = [0, 0, 0];
        this.lowestAbilities = [{}, {}, {}];
        const lowestAbilityScores = [11, 11, 11]; // highest is 10

        /**
         * Scores and targets are expected to be in the range 0-10.
         * Scores are objects with a `value` property. Target is a number array.
         * 100 means no difference, 0 is max difference, rounded to tenths.
         * If there are fewer scores than target entries, returns 0 (i.e. max difference).
         */
        const computeDifferenceScoreAndLeastFitAbilities = (scores, target, weights) => {
          console.log('Computing difference score with', { scores, target, weights });
          if (scores.length < target.length || (weights && weights.length < target.length)) return 0;
          console.log('continued computing difference score');
          const normalizedWeights = weights ? weights.map(w => w * 4) : null;
          let sumSqrDiff = 0;
          target.forEach((t, index) => {
            const diff = scores[index].value - t;
            const w = (normalizedWeights ? normalizedWeights[index] : 1);
            sumSqrDiff += (diff * diff * w); // TODO: should weights be squared as well?

            // least fit ability computation
            const weightedDiff = w * diff;
            for (let i = 0; i < leastFitAbilityDifferences.length; ++i) {
              if (weightedDiff <= leastFitAbilityDifferences[i]) {
                leastFitAbilityDifferences[i] = weightedDiff;
                this.leastFitAbilities[i] = {
                  abilityScore: scores[index].value,
                  improvementInfo: this.abilityImprovementInformation[index],
                };
                break;
              }
            }
            for (let i = lowestAbilityScores.length - 1; i >= 0; --i) {
              if (scores[index].value <= lowestAbilityScores[i]) {
                lowestAbilityScores[i] = scores[index].value;
                this.lowestAbilities[i] = {
                  abilityScore: scores[index].value,
                  improvementInfo: this.abilityImprovementInformation[index],
                };
                break;
              }
            }
          });
          // check if enough negative differences found; use lowest ability as fallback
          let fallbackIndex = 0;
          for (let i = 0; i < leastFitAbilityDifferences.length; ++i) {
            if (leastFitAbilityDifferences[i] === 0) {
              leastFitAbilityDifferences[i] = this.lowestAbilities[fallbackIndex].abilityScore;
              this.leastFitAbilities[i] = this.lowestAbilities[fallbackIndex];
              fallbackIndex += 1;
              break;
            }
          }

          const sqrtSumSqrDiff = Math.sqrt(sumSqrDiff); // ranges from 0 to maxDistance
          const maxDistance = Math.sqrt(target.length * 100); // max diff of 10 per score (& max weight of 1)
          const percentDiff = 100 * (sqrtSumSqrDiff / maxDistance);
          // 100 means no difference, 0 is max difference, rounded to tenths
          return Math.min(100, Math.max(0, Math.round((100 - percentDiff) * 10) / 10));
        };

        // NOTE: best fit just uses player-specified desired role
        this.bestFitScore =
          computeDifferenceScoreAndLeastFitAbilities(
            abilityScores,
            targetAbilityScores,
            targetAbilityWeights,
          );
        this.bestFitRoleIndex = this.desiredRoleIndex;

        // compute bestFitArchetypeIndex
        let highestCategoryScore = 0;
        this.categoryScores.forEach((categoryScore, index) => {
          if (categoryScore.value >= highestCategoryScore) {
            this.bestFitArchetypeIndex = index;
            highestCategoryScore = categoryScore.value;
          }
        });
      }
    },
    onBeforePrint(mql) {
      if (mql instanceof Event) {
        this.pdf = true;
        setTimeout(() => {
          this.pdf = false;
        }, 250);
      } else if (mql.matches) {
        this.pdf = true;
        setTimeout(() => {
          this.pdf = false;
        }, 250);
      }
    },
    iOS() {
      const platform = navigator.platform || navigator.userAgentData.platform;
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    },
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    async onClickDownload() {
      if (this.showDownloading) return;
      this.showDownloading = true;
      // PDF download works in all browsers except pre-chromium Edge
      // (fails at domtoimage.toPng, and no replacement seems viable, see above)
      // fix for Edge (for now): make the page printable, and open the print dialog automatically
      // (in response to domtoimage.toPng or any other part of the autodownload throwing any error)
      // The user can print to PDF or actually print. Bonus is you can print in other browsers too.
      // Edge requires the user to manually set the Scale in the print dialog to 50% for it to fit.
      // Note that this is generally no longer a problem with the new chromium-based Edge.
      this.pdf = true;
      try {
        const reportToPngFixed = async() => {
          await Vue.nextTick();
          let dataUrl = await domtoimage.toPng(this.$refs.report, { cacheBust: true });
          // redundant calls required to work on Safari... (https://github.com/tsayen/dom-to-image/issues/343)
          const brokenBecauseSafari = this.iOS() || this.isSafari();
          if (brokenBecauseSafari) {
            dataUrl = await domtoimage.toPng(this.$refs.report);
            dataUrl = await domtoimage.toPng(this.$refs.report);
          }
          return dataUrl;
        };

        this.pageGenerating = 0;
        await Vue.nextTick();
        await new Promise((resolve, reject) => {
          if (this.$refs.footerLogo && this.$refs.footerLogo.complete) { // wait for logo to load
            resolve();
          } else if (this.$refs.footerLogo) {
            this.$refs.footerLogo.addEventListener('load', resolve);
            this.$refs.footerLogo.addEventListener('error', reject);
          } else {
            console.log('No footerLogo ref found');
            resolve();
          }
        });
        let dataUrl = await reportToPngFixed();
        const doc = new JsPDF('p', 'pt', 'a4');
        doc.addImage(dataUrl, 'PNG', 28, 50, 540, 750);
        this.pageGenerating = 1;
        await Vue.nextTick();
        doc.addPage();
        dataUrl = await reportToPngFixed();
        doc.addImage(dataUrl, 'PNG', 28, 50, 540, 750);
        this.pageGenerating = 0;

        doc.save(`${this.reportFileName}.pdf`);

        this.pdf = false;
        this.showDownloading = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to download report PDF!', error);
        try {
          this.pdf = true;
          this.selectedTab = 0;
          await Vue.nextTick();
          window.print();
          this.pdf = false;
          this.showDownloading = false;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Failed to open print dialog!', e);
          this.pdf = false;
          this.showDownloading = false;
          this.selectedTab = 0;
        }
      }
    },

    async onClickSendEmail() {
      if (this.showDownloading) return;
      this.showDownloading = true;
      this.pdf = true;
      try {
        const reportToPngFixed = async() => {
          await Vue.nextTick();
          let dataUrl = await domtoimage.toPng(this.$refs.report, { cacheBust: true });
          const brokenBecauseSafari = this.iOS() || this.isSafari();
          if (brokenBecauseSafari) {
            dataUrl = await domtoimage.toPng(this.$refs.report);
            dataUrl = await domtoimage.toPng(this.$refs.report);
          }
          return dataUrl;
        };

        this.pageGenerating = 0;
        await Vue.nextTick();
        await new Promise((resolve, reject) => {
          if (this.$refs.footerLogo && this.$refs.footerLogo.complete) {
            resolve();
          } else if (this.$refs.footerLogo) {
            this.$refs.footerLogo.addEventListener('load', resolve);
            this.$refs.footerLogo.addEventListener('error', reject);
          } else {
            resolve();
          }
        });

        let dataUrl = await reportToPngFixed();
        const doc = new JsPDF('p', 'pt', 'a4');
        doc.addImage(dataUrl, 'PNG', 28, 50, 540, 750);
        this.pageGenerating = 1;
        await Vue.nextTick();
        doc.addPage();
        dataUrl = await reportToPngFixed();
        doc.addImage(dataUrl, 'PNG', 28, 50, 540, 750);
        this.pageGenerating = 0;

        const dataUri = doc.output('datauristring');
        const base64 = dataUri.split(',')[1];
        // call backend upload endpoint
        const to = (this.me && this.me.email) ? this.me.email : null;
        if (!to) {
          this.pdf = false;
          this.showDownloading = false;
          // TODO: proper error notification
          this.flashDanger('No email address available for this user.');
          return;
        }

        await axios.post('/blade/reports/upload-and-email', {
          to,
          pdf: base64,
          filename: `${this.reportFileName}.pdf`,
          groupId: (this.group && this.group._id) ? this.group._id : undefined,
        });

        this.pdf = false;
        this.showDownloading = false;
        // TODO: proper success notification
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to upload report', err);
        // eslint-disable-next-line no-alert
        this.flashDanger('Failed to upload report');
      } finally {
        this.pdf = false;
        this.showDownloading = false;
      }
    },
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    },
  },
  async mounted() {
    this.setStats();
    await Vue.nextTick();
    this.stopSounds();

    // polyfill for safari but works for others as well
    const mediaQueryList = (window.matchMedia != null) ? window.matchMedia('print') : null;
    if (mediaQueryList != null && mediaQueryList.addListener != null) {
      mediaQueryList.removeListener(this.onBeforePrint);
      mediaQueryList.addListener(this.onBeforePrint);
    } else {
      // what you'd normally use, if you weren't needing to support Safari:
      window.removeEventListener('beforeprint', this.onBeforePrint);
      window.addEventListener('beforeprint', this.onBeforePrint);
    }

    await this.show();

    await new Promise((resolve, reject) => {
      if (this.$refs.headingBG && this.$refs.headingBG.complete) { // wait for logo to load
        resolve();
      } else if (this.$refs.headingBG) {
        this.$refs.headingBG.addEventListener('load', resolve);
        this.$refs.headingBG.addEventListener('error', reject);
      } else {
        console.error('No headingBG ref found');
        resolve();
      }
    });

    this.showNextButton = true;
  },
};
</script>

<style lang="scss" scoped>
@media print {
  body, body * {
    visibility: hidden !important;
    overflow: visible !important;
  }
  #report-container, #report-container * {
    visibility: visible !important;
    overflow: visible !important;
  }
  #report-container {
    left: 8.75% !important;
    top: 0 !important;
    width: 82.5% !important;
    overflow: visible !important;
    z-index: 10 !important;

    // this makes background graphics show up without needing to check the box
    color-adjust: exact !important;
    print-color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
  }
}

.demographic-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  gap: 24px;
}

.no-wrap {
  white-space: nowrap;
}

.download-button {
  position: absolute;
  font-size: 28px;
  line-height: 55px;
  margin-right: 45px;
  z-index: 100 !important;
  transition: opacity 0.5s ease-in-out;
}

hr {
  border-top: 1px solid #e9ecef;
}
.report {
  background-color: white;
  color: #004282;
}
// .report.pdf {
//   border: solid;
//   border-width: 3.5px;
//   border-color: var(--primaryColor);
// }
.report-container {
  position: absolute;
  width: 1150px;
  height: 850px;
  top: 20px;
  left: 30px;
  z-index: 1;
  overflow: auto;
}

.report-page-1 {
  background: 100% no-repeat url('../../../assets/ui/reports/BG_01.png');
}
.report-page-2 {
  background: 100% no-repeat url('../../../assets/ui/reports/BG_02.png');
}

.report-header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  padding: 0 50px;
  color: black;
}
.logo {
  object-fit: contain;
  height: 90%;
  max-width: 40%;
  z-index: 10;
}
.footer-logo {
  object-fit: contain;
  max-height: 30px;
  max-width: 30%;
  margin-bottom: 15px;
  z-index: 10;
}
.report-title {
  font-size: 1.4em;
  white-space: pre-wrap;
  text-align: right;
  margin: auto 0;
  max-width: 60%;
  max-height: 100%;
  line-height: 100%;
  z-index: 1;
  color: white;
}

.primarybox {
  background-color: var(--primaryColor);
  color: white;

  color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

// https://stackoverflow.com/a/31633969/10747078
br {
  display: block;
  content: '';
  margin-top: 0.95em;
}

.slideInDown {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); // out expo
}
.fadeOutUp {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); // in cubic
}
.narrator-notification {
  bottom: 205px;
}

.download-message {
  position: absolute;
  top: 50%;
  left: 25%;
  z-index: 1000;
  border-radius: 15px;
  border: 3px solid black;
  background-color: var(--primaryColor);
  color: white;
  font-size: 30pt;
  padding: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeReportCMFC2.vue